const postcodes = [
  {
    Postcode: 2970,
    Plaatsnaam: "'s Gravenwezel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SCHILDE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "'s Herenelderen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3798,
    Plaatsnaam: "'s-Gravenvoeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VOEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7510,
    Plaatsnaam: "3 Suisses",
    Deelgemeente: null,
    Hoofdgemeente: "3 Suisses",
    Provincie: null,
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Aaigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8511,
    Plaatsnaam: "Aalbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Aalst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9300,
    Plaatsnaam: "Aalst",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9880,
    Plaatsnaam: "Aalter",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AALTER",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3200,
    Plaatsnaam: "Aarschot",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AARSCHOT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8700,
    Plaatsnaam: "Aarsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIELT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8211,
    Plaatsnaam: "Aartrijke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZEDELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2630,
    Plaatsnaam: "Aartselaar",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AARTSELAAR",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4557,
    Plaatsnaam: "Abée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINLOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Abolens",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 3930,
    Plaatsnaam: "Achel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMONT-ACHEL",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Achêne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5362,
    Plaatsnaam: "Achet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4219,
    Plaatsnaam: "Acosse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WASSEIGES",
    Provincie: "LUIK",
  },
  {
    Postcode: 6280,
    Plaatsnaam: "Acoz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERPINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1105,
    Plaatsnaam: "ACTISOC",
    Deelgemeente: null,
    Hoofdgemeente: "ACTISOC",
    Provincie: null,
  },
  {
    Postcode: 9991,
    Plaatsnaam: "Adegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MALDEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8660,
    Plaatsnaam: "Adinkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DE PANNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1790,
    Plaatsnaam: "Affligem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AFFLIGEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9051,
    Plaatsnaam: "Afsnee",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5544,
    Plaatsnaam: "Agimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASTIÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4317,
    Plaatsnaam: "Aineffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FAIMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Aische-en-Refail",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6250,
    Plaatsnaam: "Aiseau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AISEAU-PRESLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5070,
    Plaatsnaam: "Aisemont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FOSSES-LA-VILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3570,
    Plaatsnaam: "Alken",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ALKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Alle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4432,
    Plaatsnaam: "Alleur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 1652,
    Plaatsnaam: "Alsemberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEERSEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8690,
    Plaatsnaam: "Alveringem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4540,
    Plaatsnaam: "Amay",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AMAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 6680,
    Plaatsnaam: "Amberloup",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINTE-ODE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6953,
    Plaatsnaam: "Ambly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4219,
    Plaatsnaam: "Ambresin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WASSEIGES",
    Provincie: "LUIK",
  },
  {
    Postcode: 4770,
    Plaatsnaam: "Amel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AMEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 6997,
    Plaatsnaam: "Amonines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EREZÉE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7750,
    Plaatsnaam: "Amougies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONT-DE-L'ENCLUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4540,
    Plaatsnaam: "Ampsin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AMAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Andenne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1070,
    Plaatsnaam: "Anderlecht",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANDERLECHT",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 6150,
    Plaatsnaam: "Anderlues",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANDERLUES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4821,
    Plaatsnaam: "Andrimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DISON",
    Provincie: "LUIK",
  },
  {
    Postcode: 4031,
    Plaatsnaam: "Angleur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Angre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Angreau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5537,
    Plaatsnaam: "Anhée",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANHÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6721,
    Plaatsnaam: "Anlier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HABAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6890,
    Plaatsnaam: "Anloy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5537,
    Plaatsnaam: "Annevoie-Rouillon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANHÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4430,
    Plaatsnaam: "Ans",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 5500,
    Plaatsnaam: "Anseremme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7750,
    Plaatsnaam: "Anseroeul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONT-DE-L'ENCLUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5520,
    Plaatsnaam: "Anthée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ONHAYE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4520,
    Plaatsnaam: "Antheit",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WANZE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4160,
    Plaatsnaam: "Anthisnes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTHISNES",
    Provincie: "LUIK",
  },
  {
    Postcode: 7640,
    Plaatsnaam: "Antoing",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTOING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2000,
    Plaatsnaam: "Antwerpen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2018,
    Plaatsnaam: "Antwerpen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2020,
    Plaatsnaam: "Antwerpen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2030,
    Plaatsnaam: "Antwerpen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2040,
    Plaatsnaam: "Antwerpen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2050,
    Plaatsnaam: "Antwerpen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2060,
    Plaatsnaam: "Antwerpen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2099,
    Plaatsnaam: "Antwerpen X",
    Deelgemeente: null,
    Hoofdgemeente: "Antwerpen X",
    Provincie: null,
  },
  {
    Postcode: 7910,
    Plaatsnaam: "Anvaing",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8570,
    Plaatsnaam: "Anzegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ANZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Appels",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9400,
    Plaatsnaam: "Appelterre-Eichem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5170,
    Plaatsnaam: "Arbre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PROFONDEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7811,
    Plaatsnaam: "Arbre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4990,
    Plaatsnaam: "Arbrefontaine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIERNEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 7910,
    Plaatsnaam: "Arc-Ainières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7910,
    Plaatsnaam: "Arc-Wattripont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1390,
    Plaatsnaam: "Archennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GREZ-DOICEAU",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 8850,
    Plaatsnaam: "Ardooie",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ARDOOIE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2370,
    Plaatsnaam: "Arendonk",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ARENDONK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4601,
    Plaatsnaam: "Argenteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VISÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 6700,
    Plaatsnaam: "Arlon",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ARLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7181,
    Plaatsnaam: "Arquennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SENEFFE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5060,
    Plaatsnaam: "Arsimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAMBREVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6870,
    Plaatsnaam: "Arville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-HUBERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3665,
    Plaatsnaam: "As",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9404,
    Plaatsnaam: "Aspelare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9890,
    Plaatsnaam: "Asper",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GAVERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Asquillies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1730,
    Plaatsnaam: "Asse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ASSE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8310,
    Plaatsnaam: "Assebroek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1007,
    Plaatsnaam: "Assemblée de la Commission Communautaire Française",
    Deelgemeente: null,
    Hoofdgemeente: "Assemblée de la Commission Communautaire Française",
    Provincie: null,
  },
  {
    Postcode: 9960,
    Plaatsnaam: "Assenede",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ASSENEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6860,
    Plaatsnaam: "Assenois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LÉGLISE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3460,
    Plaatsnaam: "Assent",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEKKEVOORT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5330,
    Plaatsnaam: "Assesse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ASSESSE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Astene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7800,
    Plaatsnaam: "Ath",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Athis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6791,
    Plaatsnaam: "Athus",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AUBANGE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3404,
    Plaatsnaam: "Attenhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3384,
    Plaatsnaam: "Attenrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GLABBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6717,
    Plaatsnaam: "Attert",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ATTERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7941,
    Plaatsnaam: "Attre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGELETTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6790,
    Plaatsnaam: "Aubange",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AUBANGE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7972,
    Plaatsnaam: "Aubechies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4880,
    Plaatsnaam: "Aubel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AUBEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Aublain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6880,
    Plaatsnaam: "Auby-sur-Semois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTRIX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7382,
    Plaatsnaam: "Audregnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUIÉVRAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Aulnois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6706,
    Plaatsnaam: "Autelbas",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ARLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Autre-Eglise",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Autreppe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5060,
    Plaatsnaam: "Auvelais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAMBREVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Ave-et-Auffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Avekapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8580,
    Plaatsnaam: "Avelgem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4260,
    Plaatsnaam: "Avennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 3271,
    Plaatsnaam: "Averbode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SCHERPENHEUVEL-ZICHEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Avernas-le-Bauduin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Avin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4340,
    Plaatsnaam: "Awans",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AWANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 6870,
    Plaatsnaam: "Awenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-HUBERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4400,
    Plaatsnaam: "Awirs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉMALLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6900,
    Plaatsnaam: "Aye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MARCHE-EN-FAMENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4630,
    Plaatsnaam: "Ayeneux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOUMAGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4920,
    Plaatsnaam: "Aywaille",
    Deelgemeente: "Neen",
    Hoofdgemeente: "AYWAILLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9890,
    Plaatsnaam: "Baaigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GAVERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3128,
    Plaatsnaam: "Baal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TREMELO",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9310,
    Plaatsnaam: "Baardegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2387,
    Plaatsnaam: "Baarle-Hertog",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BAARLE-HERTOG",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Baasrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Bachte-Maria-Leerne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4837,
    Plaatsnaam: "Baelen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BAELEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Bagimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6464,
    Plaatsnaam: "Baileux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6460,
    Plaatsnaam: "Bailièvre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Baillamont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7730,
    Plaatsnaam: "Bailleul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTAIMPUIS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Baillonville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7380,
    Plaatsnaam: "Baisieux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUIÉVRAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1470,
    Plaatsnaam: "Baisy-Thy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Balâtre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9860,
    Plaatsnaam: "Balegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2490,
    Plaatsnaam: "Balen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BALEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Bambrugge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6951,
    Plaatsnaam: "Bande",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6500,
    Plaatsnaam: "Barbençon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4671,
    Plaatsnaam: "Barchon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BLÉGNY",
    Provincie: "LUIK",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Baronville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7534,
    Plaatsnaam: "Barry",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5370,
    Plaatsnaam: "Barvaux-Condroz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6940,
    Plaatsnaam: "Barvaux-sur-Ourthe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4520,
    Plaatsnaam: "Bas-Oha",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WANZE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7971,
    Plaatsnaam: "Basècles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4983,
    Plaatsnaam: "Basse-Bodeux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TROIS-PONTS",
    Provincie: "LUIK",
  },
  {
    Postcode: 4690,
    Plaatsnaam: "Bassenge",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BASSENGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9968,
    Plaatsnaam: "Bassevelde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSENEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Bassilly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6600,
    Plaatsnaam: "Bastogne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BASTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Batsheers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4651,
    Plaatsnaam: "Battice",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7130,
    Plaatsnaam: "Battignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7331,
    Plaatsnaam: "Baudour",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-GHISLAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7870,
    Plaatsnaam: "Bauffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LENS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7604,
    Plaatsnaam: "Baugnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1401,
    Plaatsnaam: "Baulers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIVELLES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 9520,
    Plaatsnaam: "Bavegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LIEVENS-HOUTEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8531,
    Plaatsnaam: "Bavikhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HARELBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9150,
    Plaatsnaam: "Bazel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUIBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4052,
    Plaatsnaam: "Beaufays",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAUDFONTAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6500,
    Plaatsnaam: "Beaumont",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Beauraing",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6980,
    Plaatsnaam: "Beausaint",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA ROCHE-EN-ARDENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1320,
    Plaatsnaam: "Beauvechain",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEAUVECHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6594,
    Plaatsnaam: "Beauwelz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOMIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7532,
    Plaatsnaam: "Béclers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3960,
    Plaatsnaam: "Beek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BREE",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Beerlegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8730,
    Plaatsnaam: "Beernem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEERNEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2340,
    Plaatsnaam: "Beerse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEERSE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1650,
    Plaatsnaam: "Beersel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEERSEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Beerst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1673,
    Plaatsnaam: "Beert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9080,
    Plaatsnaam: "Beervelde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOCHRISTI",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2580,
    Plaatsnaam: "Beerzel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUTTE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5000,
    Plaatsnaam: "Beez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6987,
    Plaatsnaam: "Beffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RENDEUX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3130,
    Plaatsnaam: "Begijnendijk",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEGIJNENDIJK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6672,
    Plaatsnaam: "Beho",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOUVY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1852,
    Plaatsnaam: "Beigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRIMBERGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8480,
    Plaatsnaam: "Bekegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ICHTEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1730,
    Plaatsnaam: "Bekkerzeel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3460,
    Plaatsnaam: "Bekkevoort",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEKKEVOORT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1009,
    Plaatsnaam: "Belgische Senaat",
    Deelgemeente: null,
    Hoofdgemeente: "Belgische Senaat",
    Provincie: null,
  },
  {
    Postcode: 5001,
    Plaatsnaam: "Belgrade",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4610,
    Plaatsnaam: "Bellaire",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEYNE-HEUSAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 7170,
    Plaatsnaam: "Bellecourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANAGE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Bellefontaine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6730,
    Plaatsnaam: "Bellefontaine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINTIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8510,
    Plaatsnaam: "Bellegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9881,
    Plaatsnaam: "Bellem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALTER",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6834,
    Plaatsnaam: "Bellevaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4960,
    Plaatsnaam: "Bellevaux-Ligneuville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MALMEDY",
    Provincie: "LUIK",
  },
  {
    Postcode: 1674,
    Plaatsnaam: "Bellingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7970,
    Plaatsnaam: "Beloeil",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9111,
    Plaatsnaam: "Belsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-NIKLAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4500,
    Plaatsnaam: "Ben-Ahin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HUY",
    Provincie: "LUIK",
  },
  {
    Postcode: 6941,
    Plaatsnaam: "Bende",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3540,
    Plaatsnaam: "Berbroek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERK-DE-STAD",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2600,
    Plaatsnaam: "Berchem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9690,
    Plaatsnaam: "Berchem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KLUISBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2040,
    Plaatsnaam: "Berendrecht",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1910,
    Plaatsnaam: "Berg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KAMPENHOUT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Berg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4360,
    Plaatsnaam: "Bergilers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OREYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3580,
    Plaatsnaam: "Beringen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERINGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2590,
    Plaatsnaam: "Berlaar",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERLAAR",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9290,
    Plaatsnaam: "Berlare",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERLARE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3830,
    Plaatsnaam: "Berlingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELLEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4257,
    Plaatsnaam: "Berloz",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERLOZ",
    Provincie: "LUIK",
  },
  {
    Postcode: 4607,
    Plaatsnaam: "Berneau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 7320,
    Plaatsnaam: "Bernissart",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERNISSART",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6560,
    Plaatsnaam: "Bersillies-l'Abbaye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERQUELINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3060,
    Plaatsnaam: "Bertem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6687,
    Plaatsnaam: "Bertogne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Bertrée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6880,
    Plaatsnaam: "Bertrix",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BERTRIX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5651,
    Plaatsnaam: "Berzée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8980,
    Plaatsnaam: "Beselare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZONNEBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3130,
    Plaatsnaam: "Betekom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEGIJNENDIJK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4300,
    Plaatsnaam: "Bettincourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREMME",
    Provincie: "LUIK",
  },
  {
    Postcode: 5030,
    Plaatsnaam: "Beuzet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2560,
    Plaatsnaam: "Bevel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIJLEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1547,
    Plaatsnaam: "Bever",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEVER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4960,
    Plaatsnaam: "Bevercé",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MALMEDY",
    Provincie: "LUIK",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Bevere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8791,
    Plaatsnaam: "Beveren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8800,
    Plaatsnaam: "Beveren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROESELARE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8691,
    Plaatsnaam: "Beveren-aan-de-IJzer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9120,
    Plaatsnaam: "Beveren-Waas",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3581,
    Plaatsnaam: "Beverlo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERINGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Beverst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4610,
    Plaatsnaam: "Beyne-Heusay",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BEYNE-HEUSAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 6543,
    Plaatsnaam: "Bienne-lez-Happart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOBBES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3360,
    Plaatsnaam: "Bierbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BIERBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6533,
    Plaatsnaam: "Biercée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1301,
    Plaatsnaam: "Bierges",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAVRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1430,
    Plaatsnaam: "Bierghes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "REBECQ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4460,
    Plaatsnaam: "Bierset",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRÂCE-HOLLOGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Bierwart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5640,
    Plaatsnaam: "Biesme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6531,
    Plaatsnaam: "Biesme-sous-Thuin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5640,
    Plaatsnaam: "Biesmerée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Bièvre",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1390,
    Plaatsnaam: "Biez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GREZ-DOICEAU",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6690,
    Plaatsnaam: "Bihain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIELSALM",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8920,
    Plaatsnaam: "Bikschote",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANGEMARK-POELKAPELLE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4831,
    Plaatsnaam: "Bilstain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIMBOURG",
    Provincie: "LUIK",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Bilzen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7130,
    Plaatsnaam: "Binche",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3850,
    Plaatsnaam: "Binderveld",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIEUWERKERKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3211,
    Plaatsnaam: "Binkom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LUBBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5537,
    Plaatsnaam: "Bioul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANHÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8501,
    Plaatsnaam: "Bissegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7783,
    Plaatsnaam: "Bizet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOMEN-WAASTEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2830,
    Plaatsnaam: "Blaasveld",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WILLEBROEK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5542,
    Plaatsnaam: "Blaimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASTIÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7522,
    Plaatsnaam: "Blandain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3052,
    Plaatsnaam: "Blanden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUD-HEVERLEE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8370,
    Plaatsnaam: "Blankenberge",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BLANKENBERGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Blaregnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7321,
    Plaatsnaam: "Blaton",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERNISSART",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7370,
    Plaatsnaam: "Blaugies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOUR",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4670,
    Plaatsnaam: "Blégny",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BLÉGNY",
    Provincie: "LUIK",
  },
  {
    Postcode: 7620,
    Plaatsnaam: "Bléharies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Blehen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6760,
    Plaatsnaam: "Bleid",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4300,
    Plaatsnaam: "Bleret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREMME",
    Provincie: "LUIK",
  },
  {
    Postcode: 7903,
    Plaatsnaam: "Blicquy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3950,
    Plaatsnaam: "Bocholt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BOCHOLT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4537,
    Plaatsnaam: "Bodegnée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERLAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 2530,
    Plaatsnaam: "Boechout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BOECHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3890,
    Plaatsnaam: "Boekhout",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9961,
    Plaatsnaam: "Boekhoute",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSENEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4250,
    Plaatsnaam: "Boëlhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEER",
    Provincie: "LUIK",
  },
  {
    Postcode: 8904,
    Plaatsnaam: "Boezinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1670,
    Plaatsnaam: "Bogaarden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Bohan",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5140,
    Plaatsnaam: "Boignée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMBREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4690,
    Plaatsnaam: "Boirs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASSENGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7170,
    Plaatsnaam: "Bois-d'Haine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANAGE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7866,
    Plaatsnaam: "Bois-de-Lessines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5170,
    Plaatsnaam: "Bois-de-Villers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PROFONDEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4560,
    Plaatsnaam: "Bois-et-Borsu",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CLAVIER",
    Provincie: "LUIK",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Bolinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4653,
    Plaatsnaam: "Bolland",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Bomal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6941,
    Plaatsnaam: "Bomal-sur-Ourthe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4607,
    Plaatsnaam: "Bombaye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Bommershoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7603,
    Plaatsnaam: "Bon-Secours",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4100,
    Plaatsnaam: "Boncelles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SERAING",
    Provincie: "LUIK",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Boneffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2820,
    Plaatsnaam: "Bonheiden",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BONHEIDEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5021,
    Plaatsnaam: "Boninne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1325,
    Plaatsnaam: "Bonlez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAUMONT-GISTOUX",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6700,
    Plaatsnaam: "Bonnert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ARLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Bonneville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Bonsin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2221,
    Plaatsnaam: "Booischot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEIST-OP-DEN-BERG",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Booitshoeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2850,
    Plaatsnaam: "Boom",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BOOM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3631,
    Plaatsnaam: "Boorsem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3190,
    Plaatsnaam: "Boortmeerbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BOORTMEERBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1761,
    Plaatsnaam: "Borchtlombeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROOSDAAL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2140,
    Plaatsnaam: "Borgerhout",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Borgloon",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4317,
    Plaatsnaam: "Borlez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FAIMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 3891,
    Plaatsnaam: "Borlo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6941,
    Plaatsnaam: "Borlon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2880,
    Plaatsnaam: "Bornem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BORNEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1404,
    Plaatsnaam: "Bornival",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIVELLES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 2150,
    Plaatsnaam: "Borsbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BORSBEEK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9552,
    Plaatsnaam: "Borsbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5032,
    Plaatsnaam: "Bossière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8583,
    Plaatsnaam: "Bossuit",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1390,
    Plaatsnaam: "Bossut-Gottechain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GREZ-DOICEAU",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Bost",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5032,
    Plaatsnaam: "Bothey",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9820,
    Plaatsnaam: "Bottelare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERELBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6200,
    Plaatsnaam: "Bouffioulx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHÂTELET",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5004,
    Plaatsnaam: "Bouge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Bougnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6830,
    Plaatsnaam: "Bouillon",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6464,
    Plaatsnaam: "Bourlers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Bourseigne-Neuve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Bourseigne-Vieille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7110,
    Plaatsnaam: "Boussoit",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7300,
    Plaatsnaam: "Boussu",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BOUSSU",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Boussu-en-Fagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6440,
    Plaatsnaam: "Boussu-lez-Walcourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FROIDCHAPELLE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1470,
    Plaatsnaam: "Bousval",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3370,
    Plaatsnaam: "Boutersem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BOUTERSEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5500,
    Plaatsnaam: "Bouvignes-sur-Meuse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7803,
    Plaatsnaam: "Bouvignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2288,
    Plaatsnaam: "Bouwel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GROBBENDONK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8680,
    Plaatsnaam: "Bovekerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOEKELARE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Bovelingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4300,
    Plaatsnaam: "Bovenistier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREMME",
    Provincie: "LUIK",
  },
  {
    Postcode: 5081,
    Plaatsnaam: "Bovesse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA BRUYÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6671,
    Plaatsnaam: "Bovigny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOUVY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4990,
    Plaatsnaam: "Bra",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIERNEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 7604,
    Plaatsnaam: "Braffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Braibant",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1420,
    Plaatsnaam: "Braine-l'Alleud",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRAINE-L'ALLEUD",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1440,
    Plaatsnaam: "Braine-le-Château",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRAINE-LE-CHÂTEAU",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7090,
    Plaatsnaam: "Braine-le-Comte",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRAINE-LE-COMTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4260,
    Plaatsnaam: "Braives",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Brakel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Branchon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Bras",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7604,
    Plaatsnaam: "Brasménil",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2930,
    Plaatsnaam: "Brasschaat",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRASSCHAAT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7130,
    Plaatsnaam: "Bray",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2960,
    Plaatsnaam: "Brecht",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRECHT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8450,
    Plaatsnaam: "Bredene",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BREDENE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3960,
    Plaatsnaam: "Bree",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BREE",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2870,
    Plaatsnaam: "Breendonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUURS-SINT-AMANDS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4020,
    Plaatsnaam: "Bressoux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8900,
    Plaatsnaam: "Brielen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2520,
    Plaatsnaam: "Broechem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RANST",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Broekom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1931,
    Plaatsnaam: "Brucargo",
    Deelgemeente: null,
    Hoofdgemeente: "Brucargo",
    Provincie: null,
  },
  {
    Postcode: 7940,
    Plaatsnaam: "Brugelette",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRUGELETTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8000,
    Plaatsnaam: "Brugge",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Brûly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Brûly-de-Pesche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1785,
    Plaatsnaam: "Brussegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERCHTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1000,
    Plaatsnaam: "Brussel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BRUSSEL",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 1099,
    Plaatsnaam: "Brussel X",
    Deelgemeente: null,
    Hoofdgemeente: "Brussel X",
    Provincie: null,
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Brustem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7641,
    Plaatsnaam: "Bruyelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTOING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6222,
    Plaatsnaam: "Brye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3440,
    Plaatsnaam: "Budingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOUTLEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9255,
    Plaatsnaam: "Buggenhout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BUGGENHOUT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7911,
    Plaatsnaam: "Buissenal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Buissonville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1501,
    Plaatsnaam: "Buizingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HALLE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1910,
    Plaatsnaam: "Buken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KAMPENHOUT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Bulskamp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3380,
    Plaatsnaam: "Bunsbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GLABBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2070,
    Plaatsnaam: "Burcht",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWIJNDRECHT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4210,
    Plaatsnaam: "Burdinne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BURDINNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6927,
    Plaatsnaam: "Bure",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Burst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7602,
    Plaatsnaam: "Bury",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4750,
    Plaatsnaam: "Butgenbach",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BUTGENBACH",
    Provincie: "LUIK",
  },
  {
    Postcode: 3891,
    Plaatsnaam: "Buvingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7133,
    Plaatsnaam: "Buvrinnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6743,
    Plaatsnaam: "Buzenol",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ETALLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6230,
    Plaatsnaam: "Buzet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PONT-À-CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4760,
    Plaatsnaam: "Büllingen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "BÜLLINGEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 7604,
    Plaatsnaam: "Callenelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7642,
    Plaatsnaam: "Calonne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTOING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7940,
    Plaatsnaam: "Cambron-Casteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGELETTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7870,
    Plaatsnaam: "Cambron-Saint-Vincent",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LENS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1804,
    Plaatsnaam: "Cargovil",
    Deelgemeente: null,
    Hoofdgemeente: "Cargovil",
    Provincie: null,
  },
  {
    Postcode: 6850,
    Plaatsnaam: "Carlsbourg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7141,
    Plaatsnaam: "Carnières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MORLANWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7061,
    Plaatsnaam: "Casteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Castillon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4317,
    Plaatsnaam: "Celles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FAIMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5561,
    Plaatsnaam: "Celles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7760,
    Plaatsnaam: "Celles",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4632,
    Plaatsnaam: "Cérexhe-Heuseux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOUMAGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5630,
    Plaatsnaam: "Cerfontaine",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CERFONTAINE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1341,
    Plaatsnaam: "Céroux-Mousty",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OTTIGNIES-LOUVAIN-LA-NEUVE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4650,
    Plaatsnaam: "Chaineux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Chairière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5020,
    Plaatsnaam: "Champion",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6971,
    Plaatsnaam: "Champlon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TENNEVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6921,
    Plaatsnaam: "Chanly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6742,
    Plaatsnaam: "Chantemelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ETALLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7903,
    Plaatsnaam: "Chapelle-à-Oie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7903,
    Plaatsnaam: "Chapelle-à-Wattines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7160,
    Plaatsnaam: "Chapelle-lez-Herlaimont",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHAPELLE-LEZ-HERLAIMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4537,
    Plaatsnaam: "Chapon-Seraing",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERLAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6000,
    Plaatsnaam: "Charleroi",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6099,
    Plaatsnaam: "Charleroi X",
    Deelgemeente: null,
    Hoofdgemeente: "Charleroi X",
    Provincie: null,
  },
  {
    Postcode: 4654,
    Plaatsnaam: "Charneux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6824,
    Plaatsnaam: "Chassepierre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1450,
    Plaatsnaam: "Chastre-Villeroux-Blanmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHASTRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Chastrès",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6200,
    Plaatsnaam: "Châtelet",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHÂTELET",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6200,
    Plaatsnaam: "Châtelineau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHÂTELET",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6747,
    Plaatsnaam: "Châtillon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-LÉGER",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4050,
    Plaatsnaam: "Chaudfontaine",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHAUDFONTAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 1325,
    Plaatsnaam: "Chaumont-Gistoux",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHAUMONT-GISTOUX",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7063,
    Plaatsnaam: "Chaussée-Notre-Dame-Louvignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4032,
    Plaatsnaam: "Chênée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6673,
    Plaatsnaam: "Cherain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOUVY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4602,
    Plaatsnaam: "Cheratte",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VISÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 7521,
    Plaatsnaam: "Chercq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Chevetogne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4987,
    Plaatsnaam: "Chevron",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STOUMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 7950,
    Plaatsnaam: "Chièvres",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHIÈVRES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6460,
    Plaatsnaam: "Chimay",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6810,
    Plaatsnaam: "Chiny",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CHINY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4400,
    Plaatsnaam: "Chokier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉMALLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 1031,
    Plaatsnaam: "Christelijke Sociale Organisaties",
    Deelgemeente: null,
    Hoofdgemeente: "Christelijke Sociale Organisaties",
    Provincie: null,
  },
  {
    Postcode: 5560,
    Plaatsnaam: "Ciergnon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Ciney",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4260,
    Plaatsnaam: "Ciplet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 7024,
    Plaatsnaam: "Ciply",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1480,
    Plaatsnaam: "Clabecq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TUBIZE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4560,
    Plaatsnaam: "Clavier",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CLAVIER",
    Provincie: "LUIK",
  },
  {
    Postcode: 4890,
    Plaatsnaam: "Clermont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THIMISTER-CLERMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Clermont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4480,
    Plaatsnaam: "Clermont-sous-Huy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ENGIS",
    Provincie: "LUIK",
  },
  {
    Postcode: 5022,
    Plaatsnaam: "Cognelée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7340,
    Plaatsnaam: "Colfontaine",
    Deelgemeente: "Neen",
    Hoofdgemeente: "COLFONTAINE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4170,
    Plaatsnaam: "Comblain-au-Pont",
    Deelgemeente: "Neen",
    Hoofdgemeente: "COMBLAIN-AU-PONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4180,
    Plaatsnaam: "Comblain-Fairon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIR",
    Provincie: "LUIK",
  },
  {
    Postcode: 4180,
    Plaatsnaam: "Comblain-la-Tour",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIR",
    Provincie: "LUIK",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Conneux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1435,
    Plaatsnaam: "Corbais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONT-SAINT-GUIBERT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6838,
    Plaatsnaam: "Corbion",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7910,
    Plaatsnaam: "Cordes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5620,
    Plaatsnaam: "Corenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4860,
    Plaatsnaam: "Cornesse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINSTER",
    Provincie: "LUIK",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Cornimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1935,
    Plaatsnaam: "Corporate Village",
    Deelgemeente: null,
    Hoofdgemeente: "Corporate Village",
    Provincie: null,
  },
  {
    Postcode: 5032,
    Plaatsnaam: "Corroy-le-Château",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1325,
    Plaatsnaam: "Corroy-le-Grand",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAUMONT-GISTOUX",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4257,
    Plaatsnaam: "Corswarem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERLOZ",
    Provincie: "LUIK",
  },
  {
    Postcode: 1450,
    Plaatsnaam: "Cortil-Noirmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHASTRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Cortil-Wodon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6010,
    Plaatsnaam: "Couillet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6120,
    Plaatsnaam: "Cour-sur-Heure",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAM-SUR-HEURE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6180,
    Plaatsnaam: "Courcelles",
    Deelgemeente: "Neen",
    Hoofdgemeente: "COURCELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5336,
    Plaatsnaam: "Courrière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSESSE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1490,
    Plaatsnaam: "Court-Saint-Etienne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "COURT-SAINT-ETIENNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4218,
    Plaatsnaam: "Couthuin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Coutisse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1380,
    Plaatsnaam: "Couture-Saint-Germain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LASNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Couvin",
    Deelgemeente: "Neen",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Cras-Avernas",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Crehen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4367,
    Plaatsnaam: "Crisnée",
    Deelgemeente: "Neen",
    Hoofdgemeente: "CRISNÉE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Croix-lez-Rouveroy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4784,
    Plaatsnaam: "Crombach",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SANKT-VITH",
    Provincie: "LUIK",
  },
  {
    Postcode: 5332,
    Plaatsnaam: "Crupet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSESSE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6075,
    Plaatsnaam: "CSM Charleroi X",
    Deelgemeente: null,
    Hoofdgemeente: "CSM Charleroi X",
    Provincie: null,
  },
  {
    Postcode: 9075,
    Plaatsnaam: "CSM Gent X",
    Deelgemeente: null,
    Hoofdgemeente: "CSM Gent X",
    Provincie: null,
  },
  {
    Postcode: 7033,
    Plaatsnaam: "Cuesmes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6880,
    Plaatsnaam: "Cugnon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTRIX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Cul-des-Sarts",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5562,
    Plaatsnaam: "Custinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8890,
    Plaatsnaam: "Dadizele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOORSLEDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Dailly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9160,
    Plaatsnaam: "Daknam",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOKEREN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4607,
    Plaatsnaam: "Dalhem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 8340,
    Plaatsnaam: "Damme",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DAMME",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6767,
    Plaatsnaam: "Dampicourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROUVROY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6020,
    Plaatsnaam: "Dampremy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7512,
    Plaatsnaam: "DANIEL JOUVANCE",
    Deelgemeente: null,
    Hoofdgemeente: "DANIEL JOUVANCE",
    Provincie: null,
  },
  {
    Postcode: 4253,
    Plaatsnaam: "Darion",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEER",
    Provincie: "LUIK",
  },
  {
    Postcode: 5630,
    Plaatsnaam: "Daussois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CERFONTAINE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5020,
    Plaatsnaam: "Daussoulx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5100,
    Plaatsnaam: "Dave",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6929,
    Plaatsnaam: "Daverdisse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DAVERDISSE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8420,
    Plaatsnaam: "De Haan",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DE HAAN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9170,
    Plaatsnaam: "De Klinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-GILLIS-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "De Moeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8660,
    Plaatsnaam: "De Panne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DE PANNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9840,
    Plaatsnaam: "De Pinte",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DE PINTE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8540,
    Plaatsnaam: "Deerlijk",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DEERLIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9570,
    Plaatsnaam: "Deftinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIERDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Deinze",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9280,
    Plaatsnaam: "Denderbelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEBBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9450,
    Plaatsnaam: "Denderhoutem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAALTERT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9470,
    Plaatsnaam: "Denderleeuw",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DENDERLEEUW",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Dendermonde",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9400,
    Plaatsnaam: "Denderwindeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5537,
    Plaatsnaam: "Denée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANHÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8720,
    Plaatsnaam: "Dentergem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DENTERGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7912,
    Plaatsnaam: "Dergneau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2480,
    Plaatsnaam: "Dessel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DESSEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8792,
    Plaatsnaam: "Desselgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9070,
    Plaatsnaam: "Destelbergen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DESTELBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9042,
    Plaatsnaam: "Desteldonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9831,
    Plaatsnaam: "Deurle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-MARTENS-LATEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2100,
    Plaatsnaam: "Deurne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3290,
    Plaatsnaam: "Deurne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIEST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7864,
    Plaatsnaam: "Deux-Acren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Dhuy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1831,
    Plaatsnaam: "Diegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MACHELEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3590,
    Plaatsnaam: "Diepenbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DIEPENBEEK",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3290,
    Plaatsnaam: "Diest",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DIEST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Diets-Heur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8900,
    Plaatsnaam: "Dikkebus",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Dikkele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9890,
    Plaatsnaam: "Dikkelvenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GAVERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Diksmuide",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1700,
    Plaatsnaam: "Dilbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DILBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3650,
    Plaatsnaam: "Dilsen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILSEN-STOKKEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3650,
    Plaatsnaam: "Dilsen-Stokkem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DILSEN-STOKKEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5500,
    Plaatsnaam: "Dinant",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Dion",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1325,
    Plaatsnaam: "Dion-Valmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAUMONT-GISTOUX",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4820,
    Plaatsnaam: "Dison",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DISON",
    Provincie: "LUIK",
  },
  {
    Postcode: 6960,
    Plaatsnaam: "Dochamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANHAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9130,
    Plaatsnaam: "Doel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6836,
    Plaatsnaam: "Dohan",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Doische",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4140,
    Plaatsnaam: "Dolembreux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SPRIMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4357,
    Plaatsnaam: "Donceel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DONCEEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Dongelberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3540,
    Plaatsnaam: "Donk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERK-DE-STAD",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6536,
    Plaatsnaam: "Donstiennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Dorinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3440,
    Plaatsnaam: "Dormaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOUTLEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7711,
    Plaatsnaam: "Dottenijs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOESKROEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7370,
    Plaatsnaam: "Dour",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DOUR",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Dourbes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8951,
    Plaatsnaam: "Dranouter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUVELLAND",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5500,
    Plaatsnaam: "Dréhance",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Driekapellen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Drieslinter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1620,
    Plaatsnaam: "Drogenbos",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DROGENBOS",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9031,
    Plaatsnaam: "Drongen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8380,
    Plaatsnaam: "Dudzele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2570,
    Plaatsnaam: "Duffel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DUFFEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3080,
    Plaatsnaam: "Duisburg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TERVUREN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3803,
    Plaatsnaam: "Duras",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6940,
    Plaatsnaam: "Durbuy",
    Deelgemeente: "Neen",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Durnal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1653,
    Plaatsnaam: "Dworp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEERSEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4690,
    Plaatsnaam: "Eben-Emael",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASSENGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6860,
    Plaatsnaam: "Ebly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LÉGLISE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7190,
    Plaatsnaam: "Écaussinnes-d'Enghien",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ECAUSSINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7191,
    Plaatsnaam: "Ecaussinnes-Lalaing",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ECAUSSINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2650,
    Plaatsnaam: "Edegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EDEGEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Edelare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7850,
    Plaatsnaam: "Edingen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EDINGEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9900,
    Plaatsnaam: "Eeklo",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EEKLO",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8480,
    Plaatsnaam: "Eernegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ICHTEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8740,
    Plaatsnaam: "Egem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PITTEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Eggewaartskapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Eghezée",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4120,
    Plaatsnaam: "Ehein",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUPRÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 4480,
    Plaatsnaam: "Ehein",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ENGIS",
    Provincie: "LUIK",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Eigenbilzen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2430,
    Plaatsnaam: "Eindhout",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LAAKDAL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Eine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3630,
    Plaatsnaam: "Eisden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9810,
    Plaatsnaam: "Eke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAZARETH",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2180,
    Plaatsnaam: "Ekeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9160,
    Plaatsnaam: "Eksaarde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOKEREN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3941,
    Plaatsnaam: "Eksel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HECHTEL-EKSEL",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3650,
    Plaatsnaam: "Elen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILSEN-STOKKEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Elene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1982,
    Plaatsnaam: "Elewijt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZEMST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Eliksem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1671,
    Plaatsnaam: "Elingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4590,
    Plaatsnaam: "Ellemelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUFFET",
    Provincie: "LUIK",
  },
  {
    Postcode: 7890,
    Plaatsnaam: "Ellezelles",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ELLEZELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7910,
    Plaatsnaam: "Ellignies-lez-Frasnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7972,
    Plaatsnaam: "Ellignies-Sainte-Anne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3670,
    Plaatsnaam: "Ellikom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDSBERGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7370,
    Plaatsnaam: "Elouges",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOUR",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9790,
    Plaatsnaam: "Elsegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WORTEGEM-PETEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4750,
    Plaatsnaam: "Elsenborn",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BUTGENBACH",
    Provincie: "LUIK",
  },
  {
    Postcode: 1050,
    Plaatsnaam: "Elsene",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ELSENE",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Elst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8906,
    Plaatsnaam: "Elverdinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9140,
    Plaatsnaam: "Elversele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TEMSE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2520,
    Plaatsnaam: "Emblem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RANST",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4053,
    Plaatsnaam: "Embourg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAUDFONTAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8870,
    Plaatsnaam: "Emelgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5080,
    Plaatsnaam: "Emines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA BRUYÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5363,
    Plaatsnaam: "Emptinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Ename",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Engelmanshoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4480,
    Plaatsnaam: "Engis",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ENGIS",
    Provincie: "LUIK",
  },
  {
    Postcode: 1350,
    Plaatsnaam: "Enines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ORP-JAUCHE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4800,
    Plaatsnaam: "Ensival",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERVIERS",
    Provincie: "LUIK",
  },
  {
    Postcode: 7134,
    Plaatsnaam: "Epinois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1980,
    Plaatsnaam: "Eppegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZEMST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Eprave",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7050,
    Plaatsnaam: "Erbaut",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JURBISE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7050,
    Plaatsnaam: "Erbisoeul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JURBISE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7500,
    Plaatsnaam: "Ere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9320,
    Plaatsnaam: "Erembodegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6997,
    Plaatsnaam: "Erezée",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EREZÉE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5644,
    Plaatsnaam: "Ermeton-sur-Biert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5030,
    Plaatsnaam: "Ernage",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6972,
    Plaatsnaam: "Erneuville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TENNEVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4920,
    Plaatsnaam: "Ernonheid",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AYWAILLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Erondegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Erpe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5101,
    Plaatsnaam: "Erpent",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6441,
    Plaatsnaam: "Erpion",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FROIDCHAPELLE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3071,
    Plaatsnaam: "Erps-Kwerps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6560,
    Plaatsnaam: "Erquelinnes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ERQUELINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Erquennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9940,
    Plaatsnaam: "Ertvelde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EVERGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Erwetegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7760,
    Plaatsnaam: "Escanaffles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Esen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4130,
    Plaatsnaam: "Esneux",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ESNEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 7502,
    Plaatsnaam: "Esplechin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7743,
    Plaatsnaam: "Esquelmes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PECQ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2910,
    Plaatsnaam: "Essen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ESSEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1790,
    Plaatsnaam: "Essene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AFFLIGEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7730,
    Plaatsnaam: "Estaimbourg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTAIMPUIS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7730,
    Plaatsnaam: "Estaimpuis",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ESTAIMPUIS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Estinnes-au-Mont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Estinnes-au-Val",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6740,
    Plaatsnaam: "Etalle",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ETALLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6760,
    Plaatsnaam: "Ethe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9680,
    Plaatsnaam: "Etikhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAARKEDAL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8460,
    Plaatsnaam: "Ettelgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENBURG",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1040,
    Plaatsnaam: "Etterbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ETTERBEEK",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 7080,
    Plaatsnaam: "Eugies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRAMERIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4700,
    Plaatsnaam: "Eupen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EUPEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 1046,
    Plaatsnaam: "European External Action Service",
    Deelgemeente: null,
    Hoofdgemeente: "European External Action Service",
    Provincie: null,
  },
  {
    Postcode: 1047,
    Plaatsnaam: "Europees Parlement",
    Deelgemeente: null,
    Hoofdgemeente: "Europees Parlement",
    Provincie: null,
  },
  {
    Postcode: 1049,
    Plaatsnaam: "Europese unie - Commissie",
    Deelgemeente: null,
    Hoofdgemeente: "Europese unie - Commissie",
    Provincie: null,
  },
  {
    Postcode: 1048,
    Plaatsnaam: "Europese unie - Raad",
    Deelgemeente: null,
    Hoofdgemeente: "Europese unie - Raad",
    Provincie: null,
  },
  {
    Postcode: 4631,
    Plaatsnaam: "Evegnée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOUMAGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5350,
    Plaatsnaam: "Evelette",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OHEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Everbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3078,
    Plaatsnaam: "Everberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1140,
    Plaatsnaam: "Evere",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EVERE",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 9940,
    Plaatsnaam: "Evergem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "EVERGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7730,
    Plaatsnaam: "Evregnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTAIMPUIS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Evrehailles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4731,
    Plaatsnaam: "Eynatten",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAEREN",
    Provincie: "LUIK",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Ezemaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Fagnolle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4317,
    Plaatsnaam: "Faimes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FAIMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5522,
    Plaatsnaam: "Falaën",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ONHAYE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5060,
    Plaatsnaam: "Falisolle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAMBREVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4260,
    Plaatsnaam: "Fallais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5500,
    Plaatsnaam: "Falmagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5500,
    Plaatsnaam: "Falmignoul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7181,
    Plaatsnaam: "Familleureux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SENEFFE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6240,
    Plaatsnaam: "Farciennes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FARCIENNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5340,
    Plaatsnaam: "Faulx-les-Tombes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GESVES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Fauroeulx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6637,
    Plaatsnaam: "Fauvillers",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FAUVILLERS",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4950,
    Plaatsnaam: "Faymonville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WEISMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 6856,
    Plaatsnaam: "Fays-les-Veneurs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Fayt-le-Franc",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7170,
    Plaatsnaam: "Fayt-lez-Manage",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANAGE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Felenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7181,
    Plaatsnaam: "Feluy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SENEFFE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4607,
    Plaatsnaam: "Feneur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 4190,
    Plaatsnaam: "Ferrières",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FERRIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Feschaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4347,
    Plaatsnaam: "Fexhe-le-Haut-Clocher",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FEXHE-LE-HAUT-CLOCHER",
    Provincie: "LUIK",
  },
  {
    Postcode: 4458,
    Plaatsnaam: "Fexhe-Slins",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4181,
    Plaatsnaam: "Filot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIR",
    Provincie: "LUIK",
  },
  {
    Postcode: 5560,
    Plaatsnaam: "Finnevaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4530,
    Plaatsnaam: "Fize-Fontaine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LE-BOUILLET",
    Provincie: "LUIK",
  },
  {
    Postcode: 4367,
    Plaatsnaam: "Fize-Le-Marsal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CRISNÉE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6686,
    Plaatsnaam: "Flamierge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5620,
    Plaatsnaam: "Flavion",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5020,
    Plaatsnaam: "Flawinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4400,
    Plaatsnaam: "Flémalle-Grande",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉMALLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4400,
    Plaatsnaam: "Flémalle-Haute",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉMALLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7012,
    Plaatsnaam: "Flénu",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4620,
    Plaatsnaam: "Fléron",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FLÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 6220,
    Plaatsnaam: "Fleurus",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4540,
    Plaatsnaam: "Flône",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AMAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 5334,
    Plaatsnaam: "Florée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSESSE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5150,
    Plaatsnaam: "Floreffe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FLOREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5620,
    Plaatsnaam: "Florennes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6820,
    Plaatsnaam: "Florenville",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FLORENVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5150,
    Plaatsnaam: "Floriffoux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLOREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5370,
    Plaatsnaam: "Flostoy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5572,
    Plaatsnaam: "Focant",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1212,
    Plaatsnaam: "FOD Mobiliteit",
    Deelgemeente: null,
    Hoofdgemeente: "FOD Mobiliteit",
    Provincie: null,
  },
  {
    Postcode: 1350,
    Plaatsnaam: "Folx-les-Caves",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ORP-JAUCHE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6140,
    Plaatsnaam: "Fontaine-l'Évêque",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FONTAINE-L'EVÊQUE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6567,
    Plaatsnaam: "Fontaine-Valmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERBES-LE-CHÂTEAU",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Fontenelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6820,
    Plaatsnaam: "Fontenoille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7643,
    Plaatsnaam: "Fontenoy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTOING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4340,
    Plaatsnaam: "Fooz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AWANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 6141,
    Plaatsnaam: "Forchies-La-Marche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FONTAINE-L'EVÊQUE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7910,
    Plaatsnaam: "Forest",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4870,
    Plaatsnaam: "Forêt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TROOZ",
    Provincie: "LUIK",
  },
  {
    Postcode: 6596,
    Plaatsnaam: "Forge-Philippe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOMIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6464,
    Plaatsnaam: "Forges",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6953,
    Plaatsnaam: "Forrières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Forville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4980,
    Plaatsnaam: "Fosse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TROIS-PONTS",
    Provincie: "LUIK",
  },
  {
    Postcode: 5070,
    Plaatsnaam: "Fosses-la-Ville",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FOSSES-LA-VILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Fouleng",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6440,
    Plaatsnaam: "Fourbechies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FROIDCHAPELLE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5504,
    Plaatsnaam: "Foy-Notre-Dame",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4870,
    Plaatsnaam: "Fraipont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TROOZ",
    Provincie: "LUIK",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Fraire",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4557,
    Plaatsnaam: "Fraiture",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINLOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 7080,
    Plaatsnaam: "Frameries",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FRAMERIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6853,
    Plaatsnaam: "Framont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Franc-Waret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Franchimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4970,
    Plaatsnaam: "Francorchamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STAVELOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 5150,
    Plaatsnaam: "Franière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLOREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Frasnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7911,
    Plaatsnaam: "Frasnes-lez-Buissenal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6210,
    Plaatsnaam: "Frasnes-lez-Gosselies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LES BONS VILLERS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4347,
    Plaatsnaam: "Freloux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FEXHE-LE-HAUT-CLOCHER",
    Provincie: "LUIK",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Freux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6440,
    Plaatsnaam: "Froidchapelle",
    Deelgemeente: "Neen",
    Hoofdgemeente: "FROIDCHAPELLE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5576,
    Plaatsnaam: "Froidfontaine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7504,
    Plaatsnaam: "Froidmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6990,
    Plaatsnaam: "Fronville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOTTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7503,
    Plaatsnaam: "Froyennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4260,
    Plaatsnaam: "Fumal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5500,
    Plaatsnaam: "Furfooz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5641,
    Plaatsnaam: "Furnaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1750,
    Plaatsnaam: "Gaasbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LENNIK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7943,
    Plaatsnaam: "Gages",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGELETTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7906,
    Plaatsnaam: "Gallaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1570,
    Plaatsnaam: "Galmaarden",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GALMAARDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1083,
    Plaatsnaam: "Ganshoren",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GANSHOREN",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 7530,
    Plaatsnaam: "Gaurain-Ramecroix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9890,
    Plaatsnaam: "Gavere",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GAVERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Gedinne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2440,
    Plaatsnaam: "Geel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GEEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4250,
    Plaatsnaam: "Geer",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GEER",
    Provincie: "LUIK",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Geest-Gérompont-Petit-Rosière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3450,
    Plaatsnaam: "Geetbets",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GEETBETS",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5024,
    Plaatsnaam: "Gelbressée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Gelinden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3620,
    Plaatsnaam: "Gellik",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANAKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3200,
    Plaatsnaam: "Gelrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AARSCHOT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8980,
    Plaatsnaam: "Geluveld",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZONNEBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8940,
    Plaatsnaam: "Geluwe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WERVIK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6929,
    Plaatsnaam: "Gembes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAVERDISSE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5030,
    Plaatsnaam: "Gembloux",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4851,
    Plaatsnaam: "Gemmenich",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PLOMBIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 1470,
    Plaatsnaam: "Genappe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3600,
    Plaatsnaam: "Genk",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GENK",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Genly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Genoelselderen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9000,
    Plaatsnaam: "Gent",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9099,
    Plaatsnaam: "Gent X",
    Deelgemeente: null,
    Hoofdgemeente: "Gent X",
    Provincie: null,
  },
  {
    Postcode: 9050,
    Plaatsnaam: "Gentbrugge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1450,
    Plaatsnaam: "Gentinnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHASTRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1332,
    Plaatsnaam: "Genval",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIXENSART",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Geraardsbergen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3960,
    Plaatsnaam: "Gerdingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BREE",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5524,
    Plaatsnaam: "Gérin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ONHAYE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Gérompont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6769,
    Plaatsnaam: "Gérouville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MEIX-DEVANT-VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6280,
    Plaatsnaam: "Gerpinnes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GERPINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2590,
    Plaatsnaam: "Gestel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERLAAR",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5340,
    Plaatsnaam: "Gesves",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GESVES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7822,
    Plaatsnaam: "Ghislenghien",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7011,
    Plaatsnaam: "Ghlin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7863,
    Plaatsnaam: "Ghoy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7823,
    Plaatsnaam: "Gibecq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2275,
    Plaatsnaam: "Gierle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LILLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8691,
    Plaatsnaam: "Gijverinkhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9308,
    Plaatsnaam: "Gijzegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8570,
    Plaatsnaam: "Gijzelbrechtegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9860,
    Plaatsnaam: "Gijzenzele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6060,
    Plaatsnaam: "Gilly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Gimnée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3890,
    Plaatsnaam: "Gingelom",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8470,
    Plaatsnaam: "Gistel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GISTEL",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8830,
    Plaatsnaam: "Gits",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOOGLEDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7041,
    Plaatsnaam: "Givry",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1473,
    Plaatsnaam: "Glabais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3380,
    Plaatsnaam: "Glabbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GLABBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4000,
    Plaatsnaam: "Glain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4400,
    Plaatsnaam: "Gleixhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉMALLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 1315,
    Plaatsnaam: "Glimes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "INCOURT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4690,
    Plaatsnaam: "Glons",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASSENGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Gochenée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7160,
    Plaatsnaam: "Godarville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAPELLE-LEZ-HERLAIMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Godinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Godveerdegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4834,
    Plaatsnaam: "Goé",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIMBOURG",
    Provincie: "LUIK",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Goeferdinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Goegnies-Chaussée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5353,
    Plaatsnaam: "Goesnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OHEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Goetsenhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4140,
    Plaatsnaam: "Gomzé-Andoumont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SPRIMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Gondregnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Gonrieux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9090,
    Plaatsnaam: "Gontrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MELLE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1755,
    Plaatsnaam: "Gooik",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GOOIK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Gors-Opleeuw",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3803,
    Plaatsnaam: "Gorsem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6041,
    Plaatsnaam: "Gosselies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Gotem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Gottem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7070,
    Plaatsnaam: "Gottignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LE ROEULX",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6280,
    Plaatsnaam: "Gougnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERPINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5651,
    Plaatsnaam: "Gourdinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6030,
    Plaatsnaam: "Goutroux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6670,
    Plaatsnaam: "Gouvy",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GOUVY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6181,
    Plaatsnaam: "Gouy-lez-Piéton",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COURCELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6534,
    Plaatsnaam: "Gozée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4460,
    Plaatsnaam: "Grâce-Berleur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRÂCE-HOLLOGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4460,
    Plaatsnaam: "Grâce-Hollogne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GRÂCE-HOLLOGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Graide",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Grammene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4300,
    Plaatsnaam: "Grand-Axhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREMME",
    Provincie: "LUIK",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Grand-Hallet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6698,
    Plaatsnaam: "Grand-Halleux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIELSALM",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5031,
    Plaatsnaam: "Grand-Leez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5030,
    Plaatsnaam: "Grand-Manil",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4650,
    Plaatsnaam: "Grand-Rechain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6560,
    Plaatsnaam: "Grand-Reng",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERQUELINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Grand-Rosière-Hottomont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7973,
    Plaatsnaam: "Grandglise",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6940,
    Plaatsnaam: "Grandhan",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6960,
    Plaatsnaam: "Grandménil",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANHAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7900,
    Plaatsnaam: "Grandmetz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6470,
    Plaatsnaam: "Grandrieu",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SIVRY-RANCE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4360,
    Plaatsnaam: "Grandville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OREYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6840,
    Plaatsnaam: "Grandvoir",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUFCHÂTEAU",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6840,
    Plaatsnaam: "Grapfontaine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUFCHÂTEAU",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Graty",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5640,
    Plaatsnaam: "Graux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3450,
    Plaatsnaam: "Grazen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEETBETS",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Grembergen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1390,
    Plaatsnaam: "Grez-Doiceau",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GREZ-DOICEAU",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1850,
    Plaatsnaam: "Grimbergen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GRIMBERGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9506,
    Plaatsnaam: "Grimminge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4030,
    Plaatsnaam: "Grivegnée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 2280,
    Plaatsnaam: "Grobbendonk",
    Deelgemeente: "Neen",
    Hoofdgemeente: "GROBBENDONK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1702,
    Plaatsnaam: "Groot-Bijgaarden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Groot-Gelmen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Groot-Loon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Gros-Fays",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7950,
    Plaatsnaam: "Grosage",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIÈVRES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3990,
    Plaatsnaam: "Grote-Brogel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEER",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Grote-Spouwen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Grotenberge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3670,
    Plaatsnaam: "Gruitrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDSBERGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6952,
    Plaatsnaam: "Grune",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6927,
    Plaatsnaam: "Grupont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7620,
    Plaatsnaam: "Guignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3723,
    Plaatsnaam: "Guigoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTESSEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6704,
    Plaatsnaam: "Guirsch",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ARLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8560,
    Plaatsnaam: "Gullegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WEVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Gutshoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3150,
    Plaatsnaam: "Haacht",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HAACHT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9450,
    Plaatsnaam: "Haaltert",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HAALTERT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9120,
    Plaatsnaam: "Haasdonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3053,
    Plaatsnaam: "Haasrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUD-HEVERLEE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6720,
    Plaatsnaam: "Habay-la-Neuve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HABAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6723,
    Plaatsnaam: "Habay-la-Vieille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HABAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6782,
    Plaatsnaam: "Habergy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MESSANCY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4684,
    Plaatsnaam: "Haccourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUPEYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6720,
    Plaatsnaam: "Hachy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HABAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7911,
    Plaatsnaam: "Hacquegnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5351,
    Plaatsnaam: "Haillot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OHEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7100,
    Plaatsnaam: "Haine-Saint-Paul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7100,
    Plaatsnaam: "Haine-Saint-Pierre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7350,
    Plaatsnaam: "Hainin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HENSIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Hakendover",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6792,
    Plaatsnaam: "Halanzy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AUBANGE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3545,
    Plaatsnaam: "Halen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HALEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2220,
    Plaatsnaam: "Hallaar",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEIST-OP-DEN-BERG",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1500,
    Plaatsnaam: "Halle",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HALLE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2980,
    Plaatsnaam: "Halle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOERSEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3440,
    Plaatsnaam: "Halle-Booienhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOUTLEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6986,
    Plaatsnaam: "Halleux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA ROCHE-EN-ARDENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6922,
    Plaatsnaam: "Halma",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Halmaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5340,
    Plaatsnaam: "Haltinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GESVES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6120,
    Plaatsnaam: "Ham-sur-Heure",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HAM-SUR-HEURE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Ham-sur-Sambre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6840,
    Plaatsnaam: "Hamipré",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUFCHÂTEAU",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1785,
    Plaatsnaam: "Hamme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERCHTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9220,
    Plaatsnaam: "Hamme",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HAMME",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1320,
    Plaatsnaam: "Hamme-Mille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUVECHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4180,
    Plaatsnaam: "Hamoir",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HAMOIR",
    Provincie: "LUIK",
  },
  {
    Postcode: 5360,
    Plaatsnaam: "Hamois",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HAMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3930,
    Plaatsnaam: "Hamont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMONT-ACHEL",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6990,
    Plaatsnaam: "Hampteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOTTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Han-sur-Lesse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8610,
    Plaatsnaam: "Handzame",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTEMARK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4357,
    Plaatsnaam: "Haneffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DONCEEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 4210,
    Plaatsnaam: "Hannêche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BURDINNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Hannut",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Hanret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9850,
    Plaatsnaam: "Hansbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6560,
    Plaatsnaam: "Hantes-Wihéries",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERQUELINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5621,
    Plaatsnaam: "Hanzinelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5621,
    Plaatsnaam: "Hanzinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7321,
    Plaatsnaam: "Harchies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERNISSART",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8530,
    Plaatsnaam: "Harelbeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HARELBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1130,
    Plaatsnaam: "Haren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUSSEL",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Haren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Haren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6900,
    Plaatsnaam: "Hargimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MARCHE-EN-FAMENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7022,
    Plaatsnaam: "Harmignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6767,
    Plaatsnaam: "Harnoncourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROUVROY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6960,
    Plaatsnaam: "Harre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANHAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6950,
    Plaatsnaam: "Harsin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7022,
    Plaatsnaam: "Harveng",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4920,
    Plaatsnaam: "Harzé",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AYWAILLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3500,
    Plaatsnaam: "Hasselt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5540,
    Plaatsnaam: "Hastière-Lavaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASTIÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5541,
    Plaatsnaam: "Hastière-par-Delà",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASTIÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6870,
    Plaatsnaam: "Hatrival",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-HUBERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Haulchin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4730,
    Plaatsnaam: "Hauset",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAEREN",
    Provincie: "LUIK",
  },
  {
    Postcode: 6929,
    Plaatsnaam: "Haut-Fays",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAVERDISSE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1461,
    Plaatsnaam: "Haut-Ittre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ITTRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5537,
    Plaatsnaam: "Haut-le-Wastia",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANHÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7334,
    Plaatsnaam: "Hautrage",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-GHISLAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7041,
    Plaatsnaam: "Havay",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5370,
    Plaatsnaam: "Havelange",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Haversin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7531,
    Plaatsnaam: "Havinnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7021,
    Plaatsnaam: "Havré",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3940,
    Plaatsnaam: "Hechtel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HECHTEL-EKSEL",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5543,
    Plaatsnaam: "Heer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASTIÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Heers",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Hees",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8551,
    Plaatsnaam: "Heestert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWEVEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2801,
    Plaatsnaam: "Heffen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MECHELEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1670,
    Plaatsnaam: "Heikruis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2830,
    Plaatsnaam: "Heindonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WILLEBROEK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 6700,
    Plaatsnaam: "Heinsch",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ARLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8301,
    Plaatsnaam: "Heist-aan-Zee",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KNOKKE-HEIST",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2220,
    Plaatsnaam: "Heist-op-den-Berg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HEIST-OP-DEN-BERG",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1790,
    Plaatsnaam: "Hekelgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AFFLIGEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Heks",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3530,
    Plaatsnaam: "Helchteren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUTHALEN-HELCHTEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9450,
    Plaatsnaam: "Heldergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAALTERT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3440,
    Plaatsnaam: "Helen-Bos",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOUTLEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8587,
    Plaatsnaam: "Helkijn",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SPIERE-HELKIJN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Hellebecq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9571,
    Plaatsnaam: "Hemelveerdegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIERDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2620,
    Plaatsnaam: "Hemiksem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HEMIKSEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Hemptinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5620,
    Plaatsnaam: "Hemptinne-lez-Florennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Hendrieken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Henis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7090,
    Plaatsnaam: "Hennuyères",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-LE-COMTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4841,
    Plaatsnaam: "Henri-Chapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELKENRAEDT",
    Provincie: "LUIK",
  },
  {
    Postcode: 7090,
    Plaatsnaam: "Henripont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-LE-COMTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7350,
    Plaatsnaam: "Hensies",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HENSIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3971,
    Plaatsnaam: "Heppen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEOPOLDSBURG",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4771,
    Plaatsnaam: "Heppenbach",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AMEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 6220,
    Plaatsnaam: "Heppignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6887,
    Plaatsnaam: "Herbeumont",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERBEUMONT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7050,
    Plaatsnaam: "Herchies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JURBISE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Herderen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9310,
    Plaatsnaam: "Herdersem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3020,
    Plaatsnaam: "Herent",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERENT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2200,
    Plaatsnaam: "Herentals",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERENTALS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2270,
    Plaatsnaam: "Herenthout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERENTHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1540,
    Plaatsnaam: "Herfelingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERNE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4728,
    Plaatsnaam: "Hergenrath",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KELMIS",
    Provincie: "LUIK",
  },
  {
    Postcode: 7742,
    Plaatsnaam: "Hérinnes-lez-Pecq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PECQ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3540,
    Plaatsnaam: "Herk-de-Stad",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERK-DE-STAD",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4681,
    Plaatsnaam: "Hermalle-sous-Argenteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUPEYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4480,
    Plaatsnaam: "Hermalle-sous-Huy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ENGIS",
    Provincie: "LUIK",
  },
  {
    Postcode: 4680,
    Plaatsnaam: "Hermée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUPEYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5540,
    Plaatsnaam: "Hermeton-sur-Meuse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASTIÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1540,
    Plaatsnaam: "Herne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERNE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4217,
    Plaatsnaam: "Héron",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 7911,
    Plaatsnaam: "Herquegies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7712,
    Plaatsnaam: "Herseaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOESKROEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2230,
    Plaatsnaam: "Herselt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERSELT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4040,
    Plaatsnaam: "Herstal",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERSTAL",
    Provincie: "LUIK",
  },
  {
    Postcode: 3717,
    Plaatsnaam: "Herstappe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERSTAPPE",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7522,
    Plaatsnaam: "Hertain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3831,
    Plaatsnaam: "Herten",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELLEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8020,
    Plaatsnaam: "Hertsberge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTKAMP",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4650,
    Plaatsnaam: "Herve",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9550,
    Plaatsnaam: "Herzele",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8501,
    Plaatsnaam: "Heule",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Heure",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4682,
    Plaatsnaam: "Heure-le-Romain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUPEYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Heurne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3550,
    Plaatsnaam: "Heusden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUSDEN-ZOLDER",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9070,
    Plaatsnaam: "Heusden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DESTELBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3550,
    Plaatsnaam: "Heusden-Zolder",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HEUSDEN-ZOLDER",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4802,
    Plaatsnaam: "Heusy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERVIERS",
    Provincie: "LUIK",
  },
  {
    Postcode: 3191,
    Plaatsnaam: "Hever",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOORTMEERBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3001,
    Plaatsnaam: "Heverlee",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUVEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1435,
    Plaatsnaam: "Hévillers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONT-SAINT-GUIBERT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6941,
    Plaatsnaam: "Heyd",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1733,
    Plaatsnaam: "HighCo DATA",
    Deelgemeente: null,
    Hoofdgemeente: "HighCo DATA",
    Provincie: null,
  },
  {
    Postcode: 9550,
    Plaatsnaam: "Hillegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2880,
    Plaatsnaam: "Hingene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORNEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Hingeon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6984,
    Plaatsnaam: "Hives",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA ROCHE-EN-ARDENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2660,
    Plaatsnaam: "Hoboken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4351,
    Plaatsnaam: "Hodeige",
    Deelgemeente: "Ja",
    Hoofdgemeente: "REMICOURT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6987,
    Plaatsnaam: "Hodister",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RENDEUX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4162,
    Plaatsnaam: "Hody",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTHISNES",
    Provincie: "LUIK",
  },
  {
    Postcode: 3320,
    Plaatsnaam: "Hoegaarden",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOEGAARDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1560,
    Plaatsnaam: "Hoeilaart",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOEILAART",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8340,
    Plaatsnaam: "Hoeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAMME",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3746,
    Plaatsnaam: "Hoelbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3471,
    Plaatsnaam: "Hoeleden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENAKEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Hoepertingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3730,
    Plaatsnaam: "Hoeselt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOESELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2940,
    Plaatsnaam: "Hoevenen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STABROEK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1981,
    Plaatsnaam: "Hofstade",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZEMST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9308,
    Plaatsnaam: "Hofstade",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Hogne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4342,
    Plaatsnaam: "Hognoul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AWANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 7620,
    Plaatsnaam: "Hollain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6637,
    Plaatsnaam: "Hollange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FAUVILLERS",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8902,
    Plaatsnaam: "Hollebeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4460,
    Plaatsnaam: "Hollogne-aux-Pierres",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRÂCE-HOLLOGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4250,
    Plaatsnaam: "Hollogne-sur-Geer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEER",
    Provincie: "LUIK",
  },
  {
    Postcode: 3220,
    Plaatsnaam: "Holsbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOLSBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2811,
    Plaatsnaam: "Hombeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MECHELEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4852,
    Plaatsnaam: "Hombourg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PLOMBIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 6640,
    Plaatsnaam: "Hompré",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VAUX-SUR-SÛRE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6780,
    Plaatsnaam: "Hondelange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MESSANCY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Honnay",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8830,
    Plaatsnaam: "Hooglede",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOOGLEDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8690,
    Plaatsnaam: "Hoogstade",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2320,
    Plaatsnaam: "Hoogstraten",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOOGSTRATEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4460,
    Plaatsnaam: "Horion-Hozémont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRÂCE-HOLLOGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7301,
    Plaatsnaam: "Hornu",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUSSU",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Horpmaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7060,
    Plaatsnaam: "Horrues",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6990,
    Plaatsnaam: "Hotton",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOTTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6724,
    Plaatsnaam: "Houdemont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HABAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7110,
    Plaatsnaam: "Houdeng-Aimeries",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7110,
    Plaatsnaam: "Houdeng-Goegnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Houdremont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6660,
    Plaatsnaam: "Houffalize",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOUFFALIZE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5563,
    Plaatsnaam: "Hour",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4671,
    Plaatsnaam: "Housse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BLÉGNY",
    Provincie: "LUIK",
  },
  {
    Postcode: 1476,
    Plaatsnaam: "Houtain-le-Val",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4682,
    Plaatsnaam: "Houtain-Saint-Siméon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUPEYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7812,
    Plaatsnaam: "Houtaing",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8377,
    Plaatsnaam: "Houtave",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZUIENKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Houtem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3530,
    Plaatsnaam: "Houthalen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUTHALEN-HELCHTEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7781,
    Plaatsnaam: "Houthem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOMEN-WAASTEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8650,
    Plaatsnaam: "Houthulst",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOUTHULST",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2235,
    Plaatsnaam: "Houtvenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HULSHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3390,
    Plaatsnaam: "Houwaart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIELT-WINGE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Houx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5560,
    Plaatsnaam: "Houyet",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2540,
    Plaatsnaam: "Hove",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HOVE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Hoves",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7624,
    Plaatsnaam: "Howardries",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4520,
    Plaatsnaam: "Huccorgne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WANZE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9750,
    Plaatsnaam: "Huise",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUISEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7950,
    Plaatsnaam: "Huissignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIÈVRES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1654,
    Plaatsnaam: "Huizingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEERSEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3040,
    Plaatsnaam: "Huldenberg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HULDENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2235,
    Plaatsnaam: "Hulshout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HULSHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5560,
    Plaatsnaam: "Hulsonniaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8531,
    Plaatsnaam: "Hulste",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HARELBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6900,
    Plaatsnaam: "Humain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MARCHE-EN-FAMENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1851,
    Plaatsnaam: "Humbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRIMBERGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Hundelgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Huppaye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4500,
    Plaatsnaam: "Huy",
    Deelgemeente: "Neen",
    Hoofdgemeente: "HUY",
    Provincie: "LUIK",
  },
  {
    Postcode: 7022,
    Plaatsnaam: "Hyon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8480,
    Plaatsnaam: "Ichtegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ICHTEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9472,
    Plaatsnaam: "Iddergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERLEEUW",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9506,
    Plaatsnaam: "Idegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8900,
    Plaatsnaam: "Ieper",
    Deelgemeente: "Neen",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9340,
    Plaatsnaam: "Impe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1315,
    Plaatsnaam: "Incourt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "INCOURT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 8770,
    Plaatsnaam: "Ingelmunster",
    Deelgemeente: "Neen",
    Hoofdgemeente: "INGELMUNSTER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8570,
    Plaatsnaam: "Ingooigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1041,
    Plaatsnaam: "International press center",
    Deelgemeente: null,
    Hoofdgemeente: "International press center",
    Provincie: null,
  },
  {
    Postcode: 7801,
    Plaatsnaam: "Irchonwelz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7822,
    Plaatsnaam: "Isières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5032,
    Plaatsnaam: "Isnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2222,
    Plaatsnaam: "Itegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEIST-OP-DEN-BERG",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1701,
    Plaatsnaam: "Itterbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1460,
    Plaatsnaam: "Ittre",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ITTRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4400,
    Plaatsnaam: "Ivoz-Ramet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉMALLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8870,
    Plaatsnaam: "Izegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "IZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6810,
    Plaatsnaam: "Izel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHINY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8691,
    Plaatsnaam: "Izenberge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6941,
    Plaatsnaam: "Izier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8490,
    Plaatsnaam: "Jabbeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "JABBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4845,
    Plaatsnaam: "Jalhay",
    Deelgemeente: "Neen",
    Hoofdgemeente: "JALHAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 5354,
    Plaatsnaam: "Jallet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OHEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Jamagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5100,
    Plaatsnaam: "Jambes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Jamiolle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6120,
    Plaatsnaam: "Jamioulx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAM-SUR-HEURE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6810,
    Plaatsnaam: "Jamoigne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHINY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1350,
    Plaatsnaam: "Jandrain-Jandrenouille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ORP-JAUCHE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1350,
    Plaatsnaam: "Jauche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ORP-JAUCHE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Jauchelette",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Javingue",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4540,
    Plaatsnaam: "Jehay",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AMAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 6880,
    Plaatsnaam: "Jehonville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTRIX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7012,
    Plaatsnaam: "Jemappes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Jemelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5589,
    Plaatsnaam: "Jemelle",
    Deelgemeente: null,
    Hoofdgemeente: "Jemelle",
    Provincie: null,
  },
  {
    Postcode: 4101,
    Plaatsnaam: "Jemeppe-sur-Meuse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SERAING",
    Provincie: "LUIK",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Jemeppe-sur-Sambre",
    Deelgemeente: "Neen",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4357,
    Plaatsnaam: "Jeneffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DONCEEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 5370,
    Plaatsnaam: "Jeneffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Jesseren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1090,
    Plaatsnaam: "Jette",
    Deelgemeente: "Neen",
    Hoofdgemeente: "JETTE",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 3890,
    Plaatsnaam: "Jeuk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Jodoigne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Jodoigne-Souveraine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7620,
    Plaatsnaam: "Jollain-Merlin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6280,
    Plaatsnaam: "Joncret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERPINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4650,
    Plaatsnaam: "Julémont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6040,
    Plaatsnaam: "Jumet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4020,
    Plaatsnaam: "Jupille-sur-Meuse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4450,
    Plaatsnaam: "Juprelle",
    Deelgemeente: "Neen",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7050,
    Plaatsnaam: "Jurbise",
    Deelgemeente: "Neen",
    Hoofdgemeente: "JURBISE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6642,
    Plaatsnaam: "Juseret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VAUX-SUR-SÛRE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Kaaskerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8870,
    Plaatsnaam: "Kachtem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3293,
    Plaatsnaam: "Kaggevinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIEST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7540,
    Plaatsnaam: "Kain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9270,
    Plaatsnaam: "Kalken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LAARNE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9120,
    Plaatsnaam: "Kallo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9130,
    Plaatsnaam: "Kallo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2920,
    Plaatsnaam: "Kalmthout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KALMTHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1008,
    Plaatsnaam: "Kamer van Volksvertegenwoordigers",
    Deelgemeente: null,
    Hoofdgemeente: "Kamer van Volksvertegenwoordigers",
    Provincie: null,
  },
  {
    Postcode: 1910,
    Plaatsnaam: "Kampenhout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KAMPENHOUT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8700,
    Plaatsnaam: "Kanegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIELT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Kanne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1880,
    Plaatsnaam: "Kapelle-op-den-Bos",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KAPELLE-OP-DEN-BOS",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2950,
    Plaatsnaam: "Kapellen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KAPELLEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3381,
    Plaatsnaam: "Kapellen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GLABBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9970,
    Plaatsnaam: "Kaprijke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KAPRIJKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8572,
    Plaatsnaam: "Kaster",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2460,
    Plaatsnaam: "Kasterlee",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KASTERLEE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3950,
    Plaatsnaam: "Kaulille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOCHOLT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3140,
    Plaatsnaam: "Keerbergen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KEERBERGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Keiem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4720,
    Plaatsnaam: "Kelmis",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KELMIS",
    Provincie: "LUIK",
  },
  {
    Postcode: 4367,
    Plaatsnaam: "Kemexhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CRISNÉE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8956,
    Plaatsnaam: "Kemmel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUVELLAND",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9190,
    Plaatsnaam: "Kemzeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STEKENE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8581,
    Plaatsnaam: "Kerkhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3370,
    Plaatsnaam: "Kerkom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUTERSEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Kerkom-bij-Sint-Truiden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9451,
    Plaatsnaam: "Kerksken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAALTERT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3510,
    Plaatsnaam: "Kermt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Kerniel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3472,
    Plaatsnaam: "Kersbeek-Miskom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENAKEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2560,
    Plaatsnaam: "Kessel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIJLEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3010,
    Plaatsnaam: "Kessel Lo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUVEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3640,
    Plaatsnaam: "Kessenich",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KINROOI",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1755,
    Plaatsnaam: "Kester",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOOIK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4701,
    Plaatsnaam: "Kettenis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EUPEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 5060,
    Plaatsnaam: "Keumiée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAMBREVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9130,
    Plaatsnaam: "Kieldrecht",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3640,
    Plaatsnaam: "Kinrooi",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KINROOI",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Klein-Gelmen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3990,
    Plaatsnaam: "Kleine-Brogel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEER",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Kleine-Spouwen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8420,
    Plaatsnaam: "Klemskerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DE HAAN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8650,
    Plaatsnaam: "Klerken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUTHULST",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9940,
    Plaatsnaam: "Kluizen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EVERGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9910,
    Plaatsnaam: "Knesselare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALTER",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8300,
    Plaatsnaam: "Knokke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KNOKKE-HEIST",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1730,
    Plaatsnaam: "Kobbegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8680,
    Plaatsnaam: "Koekelare",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KOEKELARE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1081,
    Plaatsnaam: "Koekelberg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KOEKELBERG",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 3582,
    Plaatsnaam: "Koersel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERINGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8670,
    Plaatsnaam: "Koksijde",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KOKSIJDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Kolmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Kolmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7780,
    Plaatsnaam: "Komen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOMEN-WAASTEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7780,
    Plaatsnaam: "Komen-Waasten",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KOMEN-WAASTEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2500,
    Plaatsnaam: "Koningshooikt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIER",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Koninksem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2550,
    Plaatsnaam: "Kontich",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KONTICH",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8510,
    Plaatsnaam: "Kooigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8000,
    Plaatsnaam: "Koolkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8851,
    Plaatsnaam: "Koolskamp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ARDOOIE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3060,
    Plaatsnaam: "Korbeek-Dijle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3360,
    Plaatsnaam: "Korbeek-Lo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIERBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8610,
    Plaatsnaam: "Kortemark",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KORTEMARK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3470,
    Plaatsnaam: "Kortenaken",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KORTENAKEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3070,
    Plaatsnaam: "Kortenberg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KORTENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3720,
    Plaatsnaam: "Kortessem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KORTESSEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3890,
    Plaatsnaam: "Kortijs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8500,
    Plaatsnaam: "Kortrijk",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3220,
    Plaatsnaam: "Kortrijk-Dutsel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOLSBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3850,
    Plaatsnaam: "Kozen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIEUWERKERKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1950,
    Plaatsnaam: "Kraainem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KRAAINEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8972,
    Plaatsnaam: "Krombeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "POPERINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9150,
    Plaatsnaam: "Kruibeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KRUIBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9770,
    Plaatsnaam: "Kruishoutem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUISEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Kumtich",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3511,
    Plaatsnaam: "Kuringen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Kuttekoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8520,
    Plaatsnaam: "Kuurne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "KUURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3945,
    Plaatsnaam: "Kwaadmechelen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9690,
    Plaatsnaam: "Kwaremont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KLUISBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1320,
    Plaatsnaam: "l'Écluse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUVECHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6464,
    Plaatsnaam: "l'Escaillère",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7080,
    Plaatsnaam: "La Bouverie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRAMERIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7611,
    Plaatsnaam: "La Glanerie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RUMES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4987,
    Plaatsnaam: "La Gleize",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STOUMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 7170,
    Plaatsnaam: "La Hestre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANAGE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1310,
    Plaatsnaam: "La Hulpe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LA HULPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7100,
    Plaatsnaam: "La Louvière",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4910,
    Plaatsnaam: "La Reid",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 6980,
    Plaatsnaam: "La Roche-en-Ardenne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LA ROCHE-EN-ARDENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Laar",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9270,
    Plaatsnaam: "Laarne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LAARNE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6567,
    Plaatsnaam: "Labuissière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERBES-LE-CHÂTEAU",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6821,
    Plaatsnaam: "Lacuisine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7950,
    Plaatsnaam: "Ladeuze",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIÈVRES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Laforêt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7890,
    Plaatsnaam: "Lahamaide",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ELLEZELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1020,
    Plaatsnaam: "Laken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUSSEL",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 7522,
    Plaatsnaam: "Lamain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4800,
    Plaatsnaam: "Lambermont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERVIERS",
    Provincie: "LUIK",
  },
  {
    Postcode: 6220,
    Plaatsnaam: "Lambusart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4350,
    Plaatsnaam: "Lamine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "REMICOURT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4210,
    Plaatsnaam: "Lamontzée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BURDINNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6767,
    Plaatsnaam: "Lamorteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROUVROY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Lampernisse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3620,
    Plaatsnaam: "Lanaken",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LANAKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4600,
    Plaatsnaam: "Lanaye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VISÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 9850,
    Plaatsnaam: "Landegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6111,
    Plaatsnaam: "Landelies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONTIGNY-LE-TILLEUL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Landen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Landenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9860,
    Plaatsnaam: "Landskouter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5651,
    Plaatsnaam: "Laneffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3201,
    Plaatsnaam: "Langdorp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AARSCHOT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8920,
    Plaatsnaam: "Langemark",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANGEMARK-POELKAPELLE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3650,
    Plaatsnaam: "Lanklaar",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILSEN-STOKKEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7800,
    Plaatsnaam: "Lanquesaint",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4450,
    Plaatsnaam: "Lantin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4300,
    Plaatsnaam: "Lantremange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREMME",
    Provincie: "LUIK",
  },
  {
    Postcode: 7622,
    Plaatsnaam: "Laplaigne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8340,
    Plaatsnaam: "Lapscheure",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAMME",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1380,
    Plaatsnaam: "Lasne-Chapelle-Saint-Lambert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LASNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Lathuy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4261,
    Plaatsnaam: "Latinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 6761,
    Plaatsnaam: "Latour",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Lauw",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8930,
    Plaatsnaam: "Lauwe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MENEN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6681,
    Plaatsnaam: "Lavacherie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINTE-ODE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Lavaux-Sainte-Anne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4217,
    Plaatsnaam: "Lavoir",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Le Mesnil",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7070,
    Plaatsnaam: "Le Roeulx",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LE ROEULX",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5070,
    Plaatsnaam: "Le Roux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FOSSES-LA-VILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9280,
    Plaatsnaam: "Lebbeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LEBBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9340,
    Plaatsnaam: "Lede",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9050,
    Plaatsnaam: "Ledeberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8880,
    Plaatsnaam: "Ledegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LEDEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3061,
    Plaatsnaam: "Leefdaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1755,
    Plaatsnaam: "Leerbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOOIK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6142,
    Plaatsnaam: "Leernes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FONTAINE-L'EVÊQUE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6530,
    Plaatsnaam: "Leers-et-Fosteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7730,
    Plaatsnaam: "Leers-Nord",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTAIMPUIS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2811,
    Plaatsnaam: "Leest",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MECHELEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Leeuwergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8432,
    Plaatsnaam: "Leffinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6860,
    Plaatsnaam: "Léglise",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LÉGLISE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Leignon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8691,
    Plaatsnaam: "Leisele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Leke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1502,
    Plaatsnaam: "Lembeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HALLE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9971,
    Plaatsnaam: "Lembeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KAPRIJKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9820,
    Plaatsnaam: "Lemberge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERELBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8860,
    Plaatsnaam: "Lendelede",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LENDELEDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7870,
    Plaatsnaam: "Lens",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LENS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Lens-Saint-Remy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4250,
    Plaatsnaam: "Lens-Saint-Servais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEER",
    Provincie: "LUIK",
  },
  {
    Postcode: 4360,
    Plaatsnaam: "Lens-sur-Geer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OREYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3970,
    Plaatsnaam: "Leopoldsburg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LEOPOLDSBURG",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4560,
    Plaatsnaam: "Les Avins",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CLAVIER",
    Provincie: "LUIK",
  },
  {
    Postcode: 6811,
    Plaatsnaam: "Les Bulles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHINY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6830,
    Plaatsnaam: "Les Hayons",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4317,
    Plaatsnaam: "Les Waleffes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FAIMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 7621,
    Plaatsnaam: "Lesdain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7860,
    Plaatsnaam: "Lessines",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Lessive",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6953,
    Plaatsnaam: "Lesterny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5170,
    Plaatsnaam: "Lesve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PROFONDEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7850,
    Plaatsnaam: "Lettelingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EDINGEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9521,
    Plaatsnaam: "Letterhoutem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LIEVENS-HOUTEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6500,
    Plaatsnaam: "Leugnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Leupegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3630,
    Plaatsnaam: "Leut",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3000,
    Plaatsnaam: "Leuven",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LEUVEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Leuze",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7900,
    Plaatsnaam: "Leuze-en-Hainaut",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6500,
    Plaatsnaam: "Leval-Chaudeville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7134,
    Plaatsnaam: "Leval-Trahegnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6238,
    Plaatsnaam: "Liberchies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PONT-À-CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6890,
    Plaatsnaam: "Libin",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIBIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Libramont-Chevigny",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2460,
    Plaatsnaam: "Lichtaart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KASTERLEE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8810,
    Plaatsnaam: "Lichtervelde",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LICHTERVELDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1770,
    Plaatsnaam: "Liedekerke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIEDEKERKE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9400,
    Plaatsnaam: "Lieferinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4000,
    Plaatsnaam: "Liège",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4020,
    Plaatsnaam: "Liège",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4099,
    Plaatsnaam: "Liège X",
    Deelgemeente: null,
    Hoofdgemeente: "Liège X",
    Provincie: null,
  },
  {
    Postcode: 2500,
    Plaatsnaam: "Lier",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIER",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4990,
    Plaatsnaam: "Lierneux",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIERNEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Liernu",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4042,
    Plaatsnaam: "Liers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERSTAL",
    Provincie: "LUIK",
  },
  {
    Postcode: 2870,
    Plaatsnaam: "Liezele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUURS-SINT-AMANDS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7812,
    Plaatsnaam: "Ligne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4254,
    Plaatsnaam: "Ligney",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEER",
    Provincie: "LUIK",
  },
  {
    Postcode: 5140,
    Plaatsnaam: "Ligny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMBREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2275,
    Plaatsnaam: "Lille",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LILLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2040,
    Plaatsnaam: "Lillo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1428,
    Plaatsnaam: "Lillois-Witterzée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-L'ALLEUD",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1300,
    Plaatsnaam: "Limal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAVRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4830,
    Plaatsnaam: "Limbourg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LIMBOURG",
    Provincie: "LUIK",
  },
  {
    Postcode: 1342,
    Plaatsnaam: "Limelette",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OTTIGNIES-LOUVAIN-LA-NEUVE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6670,
    Plaatsnaam: "Limerlé",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOUVY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4357,
    Plaatsnaam: "Limont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DONCEEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 4287,
    Plaatsnaam: "Lincent",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LINCENT",
    Provincie: "LUIK",
  },
  {
    Postcode: 3210,
    Plaatsnaam: "Linden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LUBBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1630,
    Plaatsnaam: "Linkebeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LINKEBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3560,
    Plaatsnaam: "Linkhout",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LUMMEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1357,
    Plaatsnaam: "Linsmeau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HÉLÉCINE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 2547,
    Plaatsnaam: "Lint",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LINT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Linter",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2890,
    Plaatsnaam: "Lippelo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUURS-SINT-AMANDS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5501,
    Plaatsnaam: "Lisogne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8380,
    Plaatsnaam: "Lissewege",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5101,
    Plaatsnaam: "Lives-sur-Meuse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4600,
    Plaatsnaam: "Lixhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VISÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 8647,
    Plaatsnaam: "Lo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LO-RENINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6540,
    Plaatsnaam: "Lobbes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LOBBES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9080,
    Plaatsnaam: "Lochristi",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LOCHRISTI",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6042,
    Plaatsnaam: "Lodelinsart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2990,
    Plaatsnaam: "Loenhout",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WUUSTWEZEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8958,
    Plaatsnaam: "Loker",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUVELLAND",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9160,
    Plaatsnaam: "Lokeren",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LOKEREN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3545,
    Plaatsnaam: "Loksbergen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HALEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8434,
    Plaatsnaam: "Lombardsijde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7870,
    Plaatsnaam: "Lombise",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LENS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3920,
    Plaatsnaam: "Lommel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LOMMEL",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4783,
    Plaatsnaam: "Lommersweiler",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SANKT-VITH",
    Provincie: "LUIK",
  },
  {
    Postcode: 6463,
    Plaatsnaam: "Lompret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6924,
    Plaatsnaam: "Lomprez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4431,
    Plaatsnaam: "Loncin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 1840,
    Plaatsnaam: "Londerzeel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LONDERZEEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Longchamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6688,
    Plaatsnaam: "Longchamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6840,
    Plaatsnaam: "Longlier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUFCHÂTEAU",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1325,
    Plaatsnaam: "Longueville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAUMONT-GISTOUX",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6600,
    Plaatsnaam: "Longvilly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4710,
    Plaatsnaam: "Lontzen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LONTZEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 5030,
    Plaatsnaam: "Lonzée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3040,
    Plaatsnaam: "Loonbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HULDENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8210,
    Plaatsnaam: "Loppem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZEDELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4987,
    Plaatsnaam: "Lorcé",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STOUMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 1651,
    Plaatsnaam: "Lot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEERSEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9880,
    Plaatsnaam: "Lotenhulle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALTER",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Louette-Saint-Denis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Louette-Saint-Pierre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1471,
    Plaatsnaam: "Loupoigne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1348,
    Plaatsnaam: "Louvain-la-Neuve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OTTIGNIES-LOUVAIN-LA-NEUVE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4141,
    Plaatsnaam: "Louveigné",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SPRIMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4920,
    Plaatsnaam: "Louveigné",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AYWAILLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9920,
    Plaatsnaam: "Lovendegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIEVEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3360,
    Plaatsnaam: "Lovenjoel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIERBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6280,
    Plaatsnaam: "Loverval",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERPINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5101,
    Plaatsnaam: "Loyers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3210,
    Plaatsnaam: "Lubbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LUBBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7700,
    Plaatsnaam: "Luingne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOESKROEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3560,
    Plaatsnaam: "Lummen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "LUMMEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5170,
    Plaatsnaam: "Lustin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PROFONDEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6238,
    Plaatsnaam: "Luttre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PONT-À-CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9680,
    Plaatsnaam: "Maarke-Kerkem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAARKEDAL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3680,
    Plaatsnaam: "Maaseik",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MAASEIK",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3630,
    Plaatsnaam: "Maasmechelen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6663,
    Plaatsnaam: "Mabompré",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUFFALIZE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1830,
    Plaatsnaam: "Machelen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MACHELEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9870,
    Plaatsnaam: "Machelen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZULTE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6591,
    Plaatsnaam: "Macon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOMIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6593,
    Plaatsnaam: "Macquenoise",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOMIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5374,
    Plaatsnaam: "Maffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7810,
    Plaatsnaam: "Maffle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4623,
    Plaatsnaam: "Magnée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 5330,
    Plaatsnaam: "Maillen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSESSE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7812,
    Plaatsnaam: "Mainvault",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7020,
    Plaatsnaam: "Maisières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6852,
    Plaatsnaam: "Maissin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Maizeret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Mal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9990,
    Plaatsnaam: "Maldegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MALDEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1840,
    Plaatsnaam: "Malderen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LONDERZEEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6960,
    Plaatsnaam: "Malempré",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANHAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1360,
    Plaatsnaam: "Malèves-Sainte-Marie-Wastinnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PERWEZ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 2390,
    Plaatsnaam: "Malle",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MALLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4960,
    Plaatsnaam: "Malmedy",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MALMEDY",
    Provincie: "LUIK",
  },
  {
    Postcode: 5020,
    Plaatsnaam: "Malonne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Malvoisin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7170,
    Plaatsnaam: "Manage",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MANAGE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4760,
    Plaatsnaam: "Manderfeld",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BÜLLINGEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 8433,
    Plaatsnaam: "Mannekensvere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1380,
    Plaatsnaam: "Maransart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LASNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1495,
    Plaatsnaam: "Marbais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LA-VILLE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6120,
    Plaatsnaam: "Marbaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAM-SUR-HEURE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6900,
    Plaatsnaam: "Marche-en-Famenne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MARCHE-EN-FAMENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5024,
    Plaatsnaam: "Marche-les-Dames",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7190,
    Plaatsnaam: "Marche-lez-Écaussinnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ECAUSSINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6030,
    Plaatsnaam: "Marchienne-au-Pont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4570,
    Plaatsnaam: "Marchin",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MARCHIN",
    Provincie: "LUIK",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Marchipont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Marchovelette",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6001,
    Plaatsnaam: "Marcinelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6987,
    Plaatsnaam: "Marcourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RENDEUX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6990,
    Plaatsnaam: "Marenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOTTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9030,
    Plaatsnaam: "Mariakerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2880,
    Plaatsnaam: "Mariekerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORNEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Mariembourg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1350,
    Plaatsnaam: "Marilles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ORP-JAUCHE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7850,
    Plaatsnaam: "Mark",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EDINGEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8510,
    Plaatsnaam: "Marke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8720,
    Plaatsnaam: "Markegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENTERGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4210,
    Plaatsnaam: "Marneffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BURDINNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7522,
    Plaatsnaam: "Marquain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6630,
    Plaatsnaam: "Martelange",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MARTELANGE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3742,
    Plaatsnaam: "Martenslinde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5573,
    Plaatsnaam: "Martouzin-Neuville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6953,
    Plaatsnaam: "Masbourg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7050,
    Plaatsnaam: "Masnuy-Saint-Jean",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JURBISE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7050,
    Plaatsnaam: "Masnuy-Saint-Pierre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JURBISE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9230,
    Plaatsnaam: "Massemen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WETTEREN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2240,
    Plaatsnaam: "Massenhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZANDHOVEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Matagne-la-Grande",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Matagne-la-Petite",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Mater",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7640,
    Plaatsnaam: "Maubray",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTOING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7534,
    Plaatsnaam: "Maulde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7110,
    Plaatsnaam: "Maurage",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Mazée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1745,
    Plaatsnaam: "Mazenzele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OPWIJK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5032,
    Plaatsnaam: "Mazy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5372,
    Plaatsnaam: "Méan",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2800,
    Plaatsnaam: "Mechelen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MECHELEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3630,
    Plaatsnaam: "Mechelen-aan-de-Maas",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Mechelen-Bovelingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4219,
    Plaatsnaam: "Meeffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WASSEIGES",
    Provincie: "LUIK",
  },
  {
    Postcode: 3391,
    Plaatsnaam: "Meensel-Kiezegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIELT-WINGE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2321,
    Plaatsnaam: "Meer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOOGSTRATEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3078,
    Plaatsnaam: "Meerbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9402,
    Plaatsnaam: "Meerbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9170,
    Plaatsnaam: "Meerdonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-GILLIS-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2450,
    Plaatsnaam: "Meerhout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MEERHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2328,
    Plaatsnaam: "Meerle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOOGSTRATEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3630,
    Plaatsnaam: "Meeswijk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8377,
    Plaatsnaam: "Meetkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZUIENKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3670,
    Plaatsnaam: "Meeuwen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDSBERGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Mehaigne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Meigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Meilegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1860,
    Plaatsnaam: "Meise",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MEISE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6769,
    Plaatsnaam: "Meix-devant-Virton",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MEIX-DEVANT-VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6747,
    Plaatsnaam: "Meix-le-Tige",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-LÉGER",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Melden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3320,
    Plaatsnaam: "Meldert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOEGAARDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3560,
    Plaatsnaam: "Meldert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LUMMEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9310,
    Plaatsnaam: "Meldert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4633,
    Plaatsnaam: "Melen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOUMAGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Mélin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Melkwezer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9090,
    Plaatsnaam: "Melle",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MELLE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1495,
    Plaatsnaam: "Mellery",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LA-VILLE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7540,
    Plaatsnaam: "Melles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6211,
    Plaatsnaam: "Mellet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LES BONS VILLERS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6860,
    Plaatsnaam: "Mellier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LÉGLISE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1820,
    Plaatsnaam: "Melsbroek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STEENOKKERZEEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9120,
    Plaatsnaam: "Melsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9820,
    Plaatsnaam: "Melsen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERELBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4837,
    Plaatsnaam: "Membach",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BAELEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Membre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Membruggen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9042,
    Plaatsnaam: "Mendonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8930,
    Plaatsnaam: "Menen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MENEN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6567,
    Plaatsnaam: "Merbes-le-Château",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MERBES-LE-CHÂTEAU",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6567,
    Plaatsnaam: "Merbes-Sainte-Marie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERBES-LE-CHÂTEAU",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1785,
    Plaatsnaam: "Merchtem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MERCHTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Merdorp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Mere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9820,
    Plaatsnaam: "Merelbeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MERELBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9850,
    Plaatsnaam: "Merendree",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8650,
    Plaatsnaam: "Merkem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUTHULST",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2170,
    Plaatsnaam: "Merksem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2330,
    Plaatsnaam: "Merksplas",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MERKSPLAS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Merlemont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8957,
    Plaatsnaam: "Mesen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MESEN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7822,
    Plaatsnaam: "Meslin-l'Évêque",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5560,
    Plaatsnaam: "Mesnil-Eglise",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5560,
    Plaatsnaam: "Mesnil-Saint-Blaise",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Mespelare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6780,
    Plaatsnaam: "Messancy",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MESSANCY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3272,
    Plaatsnaam: "Messelbroek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SCHERPENHEUVEL-ZICHEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7022,
    Plaatsnaam: "Mesvin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Mettekoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5640,
    Plaatsnaam: "Mettet",
    Deelgemeente: "Neen",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8760,
    Plaatsnaam: "Meulebeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MEULEBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5081,
    Plaatsnaam: "Meux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA BRUYÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7942,
    Plaatsnaam: "Mévergnies-lez-Lens",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGELETTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4770,
    Plaatsnaam: "Meyerode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AMEL",
    Provincie: "LUIK",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Michelbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4630,
    Plaatsnaam: "Micheroux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOUMAGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9992,
    Plaatsnaam: "Middelburg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MALDEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8430,
    Plaatsnaam: "Middelkerke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5376,
    Plaatsnaam: "Miécret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3891,
    Plaatsnaam: "Mielen-boven-Aalst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7070,
    Plaatsnaam: "Mignault",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LE ROEULX",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Millen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4041,
    Plaatsnaam: "Milmort",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERSTAL",
    Provincie: "LUIK",
  },
  {
    Postcode: 2322,
    Plaatsnaam: "Minderhout",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOOGSTRATEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1035,
    Plaatsnaam: "Ministerie van het Brussels Hoofdstedelijk Gewest",
    Deelgemeente: null,
    Hoofdgemeente: "Ministerie van het Brussels Hoofdstedelijk Gewest",
    Provincie: null,
  },
  {
    Postcode: 6870,
    Plaatsnaam: "Mirwart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-HUBERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4577,
    Plaatsnaam: "Modave",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MODAVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3790,
    Plaatsnaam: "Moelingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VOEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8552,
    Plaatsnaam: "Moen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWEVEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Moerbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9180,
    Plaatsnaam: "Moerbeke-Waas",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MOERBEKE-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8470,
    Plaatsnaam: "Moere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GISTEL",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8340,
    Plaatsnaam: "Moerkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAMME",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9220,
    Plaatsnaam: "Moerzeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMME",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7700,
    Plaatsnaam: "Moeskroen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MOESKROEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4520,
    Plaatsnaam: "Moha",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WANZE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5361,
    Plaatsnaam: "Mohiville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5060,
    Plaatsnaam: "Moignelée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAMBREVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Moircy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2400,
    Plaatsnaam: "Mol",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MOL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7760,
    Plaatsnaam: "Molenbaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3461,
    Plaatsnaam: "Molenbeek-Wersbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEKKEVOORT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3640,
    Plaatsnaam: "Molenbeersel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KINROOI",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3294,
    Plaatsnaam: "Molenstede",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIEST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1730,
    Plaatsnaam: "Mollem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4350,
    Plaatsnaam: "Momalle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "REMICOURT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6590,
    Plaatsnaam: "Momignies",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MOMIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Monceau-en-Ardenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6592,
    Plaatsnaam: "Monceau-Imbrechies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOMIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6031,
    Plaatsnaam: "Monceau-sur-Sambre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7000,
    Plaatsnaam: "Mons",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4400,
    Plaatsnaam: "Mons-lez-Liège",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉMALLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 1400,
    Plaatsnaam: "Monstreux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIVELLES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Mont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6661,
    Plaatsnaam: "Mont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUFFALIZE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Mont-Gauthier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Mont-Saint-André",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7542,
    Plaatsnaam: "Mont-Saint-Aubert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1435,
    Plaatsnaam: "Mont-Saint-Guibert",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MONT-SAINT-GUIBERT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7141,
    Plaatsnaam: "Mont-Sainte-Aldegonde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MORLANWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6540,
    Plaatsnaam: "Mont-Sainte-Geneviève",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOBBES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6032,
    Plaatsnaam: "Mont-sur-Marchienne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6470,
    Plaatsnaam: "Montbliart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SIVRY-RANCE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4420,
    Plaatsnaam: "Montegnée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-NICOLAS",
    Provincie: "LUIK",
  },
  {
    Postcode: 3890,
    Plaatsnaam: "Montenaken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7870,
    Plaatsnaam: "Montignies-lez-Lens",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LENS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6560,
    Plaatsnaam: "Montignies-Saint-Christophe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERQUELINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Montignies-sur-Roc",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6061,
    Plaatsnaam: "Montignies-sur-Sambre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6110,
    Plaatsnaam: "Montigny-le-Tilleul",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MONTIGNY-LE-TILLEUL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6674,
    Plaatsnaam: "Montleban",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOUVY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7911,
    Plaatsnaam: "Montrul-au-Bois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7350,
    Plaatsnaam: "Montrul-sur-Haine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HENSIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4850,
    Plaatsnaam: "Montzen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PLOMBIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 9310,
    Plaatsnaam: "Moorsel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8560,
    Plaatsnaam: "Moorsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WEVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8890,
    Plaatsnaam: "Moorslede",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MOORSLEDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9860,
    Plaatsnaam: "Moortsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Mopertingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9790,
    Plaatsnaam: "Moregem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WORTEGEM-PETEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4850,
    Plaatsnaam: "Moresnet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PLOMBIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 6640,
    Plaatsnaam: "Morhet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VAUX-SUR-SÛRE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5621,
    Plaatsnaam: "Morialmé",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2200,
    Plaatsnaam: "Morkhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERENTALS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7140,
    Plaatsnaam: "Morlanwelz-Mariemont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MORLANWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6997,
    Plaatsnaam: "Mormont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EREZÉE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Mornimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4670,
    Plaatsnaam: "Mortier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BLÉGNY",
    Provincie: "LUIK",
  },
  {
    Postcode: 4607,
    Plaatsnaam: "Mortroux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 2640,
    Plaatsnaam: "Mortsel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MORTSEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5620,
    Plaatsnaam: "Morville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7812,
    Plaatsnaam: "Moulbaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7543,
    Plaatsnaam: "Mourcourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7911,
    Plaatsnaam: "Moustier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Moustier-sur-Sambre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Mouzaive",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Moxhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 5340,
    Plaatsnaam: "Mozet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GESVES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2812,
    Plaatsnaam: "Muizen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MECHELEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3891,
    Plaatsnaam: "Muizen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Mullem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Munkzwalm",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6820,
    Plaatsnaam: "Muno",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Munsterbilzen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9820,
    Plaatsnaam: "Munte",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERELBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6750,
    Plaatsnaam: "Musson",
    Deelgemeente: "Neen",
    Hoofdgemeente: "MUSSON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6750,
    Plaatsnaam: "Mussy-la-Ville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MUSSON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4190,
    Plaatsnaam: "My",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERRIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 7062,
    Plaatsnaam: "Naast",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6660,
    Plaatsnaam: "Nadrin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUFFALIZE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Nafraiture",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6120,
    Plaatsnaam: "Nalinnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAM-SUR-HEURE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Namêche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5000,
    Plaatsnaam: "Namur",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4550,
    Plaatsnaam: "Nandrin",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NANDRIN",
    Provincie: "LUIK",
  },
  {
    Postcode: 5100,
    Plaatsnaam: "Naninne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Naomé",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6950,
    Plaatsnaam: "Nassogne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NASSOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1110,
    Plaatsnaam: "NATO",
    Deelgemeente: null,
    Hoofdgemeente: "NATO",
    Provincie: null,
  },
  {
    Postcode: 5360,
    Plaatsnaam: "Natoye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9810,
    Plaatsnaam: "Nazareth",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NAZARETH",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7730,
    Plaatsnaam: "Néchin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTAIMPUIS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1120,
    Plaatsnaam: "Neder-Over-Heembeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUSSEL",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Nederboelare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Nederbrakel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Nederename",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9400,
    Plaatsnaam: "Nederhasselt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1910,
    Plaatsnaam: "Nederokkerzeel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KAMPENHOUT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9636,
    Plaatsnaam: "Nederzwalm-Hermelgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3670,
    Plaatsnaam: "Neerglabbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDSBERGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3620,
    Plaatsnaam: "Neerharen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANAKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Neerhespen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1357,
    Plaatsnaam: "Neerheylissem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HÉLÉCINE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3040,
    Plaatsnaam: "Neerijse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HULDENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3404,
    Plaatsnaam: "Neerlanden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Neerlinter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3680,
    Plaatsnaam: "Neeroeteren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASEIK",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3910,
    Plaatsnaam: "Neerpelt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Neerrepen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3370,
    Plaatsnaam: "Neervelp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUTERSEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7784,
    Plaatsnaam: "Neerwaasten",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOMEN-WAASTEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Neerwinden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9403,
    Plaatsnaam: "Neigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Nerem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4870,
    Plaatsnaam: "Nessonvaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TROOZ",
    Provincie: "LUIK",
  },
  {
    Postcode: 1390,
    Plaatsnaam: "Nethen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GREZ-DOICEAU",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Nettinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4721,
    Plaatsnaam: "Neu-Moresnet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KELMIS",
    Provincie: "LUIK",
  },
  {
    Postcode: 4608,
    Plaatsnaam: "Neufchâteau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 6840,
    Plaatsnaam: "Neufchâteau",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NEUFCHÂTEAU",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7332,
    Plaatsnaam: "Neufmaison",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-GHISLAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7063,
    Plaatsnaam: "Neufvilles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Neuville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4121,
    Plaatsnaam: "Neuville-en-Condroz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUPRÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 9850,
    Plaatsnaam: "Nevele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2845,
    Plaatsnaam: "Niel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NIEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3668,
    Plaatsnaam: "Niel-bij-As",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3890,
    Plaatsnaam: "Niel-bij-Sint-Truiden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9506,
    Plaatsnaam: "Nieuwenhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1880,
    Plaatsnaam: "Nieuwenrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KAPELLE-OP-DEN-BOS",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3850,
    Plaatsnaam: "Nieuwerkerken",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NIEUWERKERKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9320,
    Plaatsnaam: "Nieuwerkerken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALST",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Nieuwkapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8950,
    Plaatsnaam: "Nieuwkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUVELLAND",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9100,
    Plaatsnaam: "Nieuwkerken-Waas",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-NIKLAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8377,
    Plaatsnaam: "Nieuwmunster",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZUIENKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8620,
    Plaatsnaam: "Nieuwpoort",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NIEUWPOORT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3221,
    Plaatsnaam: "Nieuwrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOLSBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2560,
    Plaatsnaam: "Nijlen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NIJLEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1457,
    Plaatsnaam: "Nil-Saint-Vincent-Saint-Martin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7020,
    Plaatsnaam: "Nimy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9400,
    Plaatsnaam: "Ninove",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Nismes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1400,
    Plaatsnaam: "Nivelles",
    Deelgemeente: "Neen",
    Hoofdgemeente: "NIVELLES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Niverlée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6640,
    Plaatsnaam: "Nives",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VAUX-SUR-SÛRE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6717,
    Plaatsnaam: "Nobressart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATTERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1320,
    Plaatsnaam: "Nodebais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUVECHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1350,
    Plaatsnaam: "Noduwez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ORP-JAUCHE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7080,
    Plaatsnaam: "Noirchain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRAMERIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6831,
    Plaatsnaam: "Noirfontaine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Noiseux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9771,
    Plaatsnaam: "Nokere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUISEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6851,
    Plaatsnaam: "Nollevaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2200,
    Plaatsnaam: "Noorderwijk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERENTALS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8647,
    Plaatsnaam: "Noordschote",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LO-RENINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1930,
    Plaatsnaam: "Nossegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZAVENTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6717,
    Plaatsnaam: "Nothomb",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATTERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7022,
    Plaatsnaam: "Nouvelles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4347,
    Plaatsnaam: "Noville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FEXHE-LE-HAUT-CLOCHER",
    Provincie: "LUIK",
  },
  {
    Postcode: 6600,
    Plaatsnaam: "Noville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Noville-les-Bois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Noville-sur-Mehaigne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9681,
    Plaatsnaam: "Nukerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAARKEDAL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6230,
    Plaatsnaam: "Obaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PONT-À-CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7743,
    Plaatsnaam: "Obigies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PECQ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7034,
    Plaatsnaam: "Obourg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6890,
    Plaatsnaam: "Ochamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4560,
    Plaatsnaam: "Ocquier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CLAVIER",
    Provincie: "LUIK",
  },
  {
    Postcode: 6960,
    Plaatsnaam: "Odeigne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANHAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4367,
    Plaatsnaam: "Odeur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CRISNÉE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8730,
    Plaatsnaam: "Oedelem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEERNEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8800,
    Plaatsnaam: "Oekene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROESELARE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2520,
    Plaatsnaam: "Oelegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RANST",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8690,
    Plaatsnaam: "Oeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8720,
    Plaatsnaam: "Oeselgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENTERGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1755,
    Plaatsnaam: "Oetingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GOOIK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7911,
    Plaatsnaam: "Oeudeghien",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2260,
    Plaatsnaam: "Oevel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WESTERLO",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 6850,
    Plaatsnaam: "Offagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1934,
    Plaatsnaam: "Office Exchange Brussels Airport Remailing",
    Deelgemeente: null,
    Hoofdgemeente: "Office Exchange Brussels Airport Remailing",
    Provincie: null,
  },
  {
    Postcode: 7862,
    Plaatsnaam: "Ogy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1380,
    Plaatsnaam: "Ohain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LASNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5350,
    Plaatsnaam: "Ohey",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OHEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Oignies-en-Thiérache",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1480,
    Plaatsnaam: "Oisquercq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TUBIZE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Oizy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9400,
    Plaatsnaam: "Okegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2250,
    Plaatsnaam: "Olen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OLEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4300,
    Plaatsnaam: "Oleye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREMME",
    Provincie: "LUIK",
  },
  {
    Postcode: 7866,
    Plaatsnaam: "Ollignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Olloy-Sur-Viroin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2491,
    Plaatsnaam: "Olmen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BALEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4877,
    Plaatsnaam: "Olne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OLNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9870,
    Plaatsnaam: "Olsene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZULTE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4252,
    Plaatsnaam: "Omal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEER",
    Provincie: "LUIK",
  },
  {
    Postcode: 4540,
    Plaatsnaam: "Ombret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AMAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Omezée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6900,
    Plaatsnaam: "On",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MARCHE-EN-FAMENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5520,
    Plaatsnaam: "Onhaye",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ONHAYE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Onkerzele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Onnezies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Onoz",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1760,
    Plaatsnaam: "Onze-Lieve-Vrouw-Lombeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROOSDAAL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2861,
    Plaatsnaam: "Onze-Lieve-Vrouw-Waver",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-KATELIJNE-WAVER",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8710,
    Plaatsnaam: "Ooigem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WIELSBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Ooike",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9790,
    Plaatsnaam: "Ooike",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WORTEGEM-PETEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9520,
    Plaatsnaam: "Oombergen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LIEVENS-HOUTEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Oombergen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Oorbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9340,
    Plaatsnaam: "Oordegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9041,
    Plaatsnaam: "Oostakker",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8670,
    Plaatsnaam: "Oostduinkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOKSIJDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9968,
    Plaatsnaam: "Oosteeklo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSENEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8400,
    Plaatsnaam: "Oostende",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OOSTENDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9860,
    Plaatsnaam: "Oosterzele",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OOSTERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3945,
    Plaatsnaam: "Oostham",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8020,
    Plaatsnaam: "Oostkamp",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OOSTKAMP",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8340,
    Plaatsnaam: "Oostkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAMME",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Oostkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2390,
    Plaatsnaam: "Oostmalle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MALLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8840,
    Plaatsnaam: "Oostnieuwkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STADEN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8780,
    Plaatsnaam: "Oostrozebeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OOSTROZEBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8640,
    Plaatsnaam: "Oostvleteren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VLETEREN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9931,
    Plaatsnaam: "Oostwinkel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIEVEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Opbrakel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9255,
    Plaatsnaam: "Opdorp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BUGGENHOUT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3660,
    Plaatsnaam: "Opglabbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDSBERGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3630,
    Plaatsnaam: "Opgrimbie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1421,
    Plaatsnaam: "Ophain-Bois-Seigneur-Isaac",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-L'ALLEUD",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Ophasselt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Opheers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1357,
    Plaatsnaam: "Opheylissem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HÉLÉCINE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3640,
    Plaatsnaam: "Ophoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KINROOI",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3960,
    Plaatsnaam: "Opitter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BREE",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Oplinter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3680,
    Plaatsnaam: "Opoeteren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASEIK",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6852,
    Plaatsnaam: "Opont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1315,
    Plaatsnaam: "Opprebais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "INCOURT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 2890,
    Plaatsnaam: "Oppuurs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUURS-SINT-AMANDS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3360,
    Plaatsnaam: "Opvelp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIERBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1745,
    Plaatsnaam: "Opwijk",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OPWIJK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1360,
    Plaatsnaam: "Orbais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PERWEZ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Orchimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7501,
    Plaatsnaam: "Orcq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Ordingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5640,
    Plaatsnaam: "Oret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4360,
    Plaatsnaam: "Oreye",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OREYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6880,
    Plaatsnaam: "Orgeo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERTRIX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7802,
    Plaatsnaam: "Ormeignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1350,
    Plaatsnaam: "Orp-le-Grand",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ORP-JAUCHE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7750,
    Plaatsnaam: "Orroir",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONT-DE-L'ENCLUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Orsmaal-Gussenhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6983,
    Plaatsnaam: "Ortho",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA ROCHE-EN-ARDENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7804,
    Plaatsnaam: "Ostiches",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8553,
    Plaatsnaam: "Otegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWEVEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4210,
    Plaatsnaam: "Oteppe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BURDINNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4340,
    Plaatsnaam: "Othée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AWANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 4360,
    Plaatsnaam: "Otrange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OREYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3040,
    Plaatsnaam: "Ottenburg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HULDENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Ottergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1340,
    Plaatsnaam: "Ottignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OTTIGNIES-LOUVAIN-LA-NEUVE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3050,
    Plaatsnaam: "Oud-Heverlee",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OUD-HEVERLEE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2360,
    Plaatsnaam: "Oud-Turnhout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OUD-TURNHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Oudegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Oudekapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Oudenaarde",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1600,
    Plaatsnaam: "Oudenaken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-PIETERS-LEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8460,
    Plaatsnaam: "Oudenburg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OUDENBURG",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1160,
    Plaatsnaam: "Oudergem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OUDERGEM",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 4590,
    Plaatsnaam: "Ouffet",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OUFFET",
    Provincie: "LUIK",
  },
  {
    Postcode: 4102,
    Plaatsnaam: "Ougrée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SERAING",
    Provincie: "LUIK",
  },
  {
    Postcode: 4680,
    Plaatsnaam: "Oupeye",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OUPEYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9406,
    Plaatsnaam: "Outer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3321,
    Plaatsnaam: "Outgaarden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOEGAARDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4577,
    Plaatsnaam: "Outrelouxhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MODAVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8582,
    Plaatsnaam: "Outrijve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9750,
    Plaatsnaam: "Ouwegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUISEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Overboelare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Overhespen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3090,
    Plaatsnaam: "Overijse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "OVERIJSE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9290,
    Plaatsnaam: "Overmere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERLARE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3900,
    Plaatsnaam: "Overpelt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Overrepen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Overwinden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3583,
    Plaatsnaam: "Paal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERINGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4452,
    Plaatsnaam: "Paifve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4560,
    Plaatsnaam: "Pailhe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CLAVIER",
    Provincie: "LUIK",
  },
  {
    Postcode: 6850,
    Plaatsnaam: "Paliseul",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PALISEUL",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1760,
    Plaatsnaam: "Pamel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROOSDAAL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7861,
    Plaatsnaam: "Papignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9661,
    Plaatsnaam: "Parike",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1012,
    Plaatsnaam: "Parlement de la communauté française",
    Deelgemeente: null,
    Hoofdgemeente: "Parlement de la communauté française",
    Provincie: null,
  },
  {
    Postcode: 5012,
    Plaatsnaam: "Parlement Wallon",
    Deelgemeente: null,
    Hoofdgemeente: "Parlement Wallon",
    Provincie: null,
  },
  {
    Postcode: 8980,
    Plaatsnaam: "Passendale",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZONNEBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Patignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7340,
    Plaatsnaam: "Pâturages",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COLFONTAINE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Paulatem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7740,
    Plaatsnaam: "Pecq",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PECQ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3990,
    Plaatsnaam: "Peer",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PEER",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Peissant",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4287,
    Plaatsnaam: "Pellaines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINCENT",
    Provincie: "LUIK",
  },
  {
    Postcode: 3212,
    Plaatsnaam: "Pellenberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LUBBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1670,
    Plaatsnaam: "Pepingen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PEPINGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4860,
    Plaatsnaam: "Pepinster",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PEPINSTER",
    Provincie: "LUIK",
  },
  {
    Postcode: 1820,
    Plaatsnaam: "Perk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STEENOKKERZEEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7640,
    Plaatsnaam: "Péronnes-lez-Antoing",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTOING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7134,
    Plaatsnaam: "Péronnes-lez-Binche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7600,
    Plaatsnaam: "Péruwelz",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Pervijze",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1360,
    Plaatsnaam: "Perwez",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PERWEZ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5352,
    Plaatsnaam: "Perwez-Haillot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OHEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Pesche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Pessoux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Petegem-aan-de-Leie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9790,
    Plaatsnaam: "Petegem-aan-de-Schelde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WORTEGEM-PETEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Pétigny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5555,
    Plaatsnaam: "Petit-Fays",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BIÈVRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Petit-Hallet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4800,
    Plaatsnaam: "Petit-Rechain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERVIERS",
    Provincie: "LUIK",
  },
  {
    Postcode: 7090,
    Plaatsnaam: "Petit-Rulx-lez-Braine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-LE-COMTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7181,
    Plaatsnaam: "Petit-Rulx-lez-Nivelles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SENEFFE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6692,
    Plaatsnaam: "Petit-Thier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIELSALM",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Petite-Chapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1800,
    Plaatsnaam: "Peutie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILVOORDE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Philippeville",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7160,
    Plaatsnaam: "Piéton",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAPELLE-LEZ-HERLAIMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Piétrain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1315,
    Plaatsnaam: "Piétrebais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "INCOURT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7904,
    Plaatsnaam: "Pipaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Piringen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6240,
    Plaatsnaam: "Pironchamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FARCIENNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8740,
    Plaatsnaam: "Pittem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PITTEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4122,
    Plaatsnaam: "Plainevaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUPRÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 1380,
    Plaatsnaam: "Plancenoit",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LASNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7782,
    Plaatsnaam: "Ploegsteert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOMEN-WAASTEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 2275,
    Plaatsnaam: "Poederlee",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LILLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9880,
    Plaatsnaam: "Poeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALTER",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8920,
    Plaatsnaam: "Poelkapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANGEMARK-POELKAPELLE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9850,
    Plaatsnaam: "Poesele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9401,
    Plaatsnaam: "Pollare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4800,
    Plaatsnaam: "Polleur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERVIERS",
    Provincie: "LUIK",
  },
  {
    Postcode: 4910,
    Plaatsnaam: "Polleur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 8647,
    Plaatsnaam: "Pollinkhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LO-RENINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7322,
    Plaatsnaam: "Pommeroeul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERNISSART",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5574,
    Plaatsnaam: "Pondrôme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6230,
    Plaatsnaam: "Pont-à-Celles",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PONT-À-CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6250,
    Plaatsnaam: "Pont-de-Loup",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AISEAU-PRESLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Pontillas",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8970,
    Plaatsnaam: "Poperinge",
    Deelgemeente: "Neen",
    Hoofdgemeente: "POPERINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2382,
    Plaatsnaam: "Poppel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAVELS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7760,
    Plaatsnaam: "Popuelles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5370,
    Plaatsnaam: "Porcheresse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6929,
    Plaatsnaam: "Porcheresse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAVERDISSE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1100,
    Plaatsnaam: "Postcheque",
    Deelgemeente: null,
    Hoofdgemeente: "Postcheque",
    Provincie: null,
  },
  {
    Postcode: 7760,
    Plaatsnaam: "Pottes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Poucet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4171,
    Plaatsnaam: "Poulseur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COMBLAIN-AU-PONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6830,
    Plaatsnaam: "Poupehan",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4350,
    Plaatsnaam: "Pousset",
    Deelgemeente: "Ja",
    Hoofdgemeente: "REMICOURT",
    Provincie: "LUIK",
  },
  {
    Postcode: 5660,
    Plaatsnaam: "Presgaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COUVIN",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6250,
    Plaatsnaam: "Presles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AISEAU-PRESLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5170,
    Plaatsnaam: "Profondeville",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PROFONDEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8972,
    Plaatsnaam: "Proven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "POPERINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Pry",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2242,
    Plaatsnaam: "Pulderbos",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZANDHOVEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2243,
    Plaatsnaam: "Pulle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZANDHOVEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Purnode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Pussemange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2580,
    Plaatsnaam: "Putte",
    Deelgemeente: "Neen",
    Hoofdgemeente: "PUTTE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2870,
    Plaatsnaam: "Puurs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUURS-SINT-AMANDS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7390,
    Plaatsnaam: "Quaregnon",
    Deelgemeente: "Neen",
    Hoofdgemeente: "QUAREGNON",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7540,
    Plaatsnaam: "Quartes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1430,
    Plaatsnaam: "Quenast",
    Deelgemeente: "Ja",
    Hoofdgemeente: "REBECQ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4610,
    Plaatsnaam: "Queue-du-Bois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEYNE-HEUSAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 7972,
    Plaatsnaam: "Quevaucamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Quévy-le-Grand",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7040,
    Plaatsnaam: "Quévy-le-Petit",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUÉVY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7380,
    Plaatsnaam: "Quiévrain",
    Deelgemeente: "Neen",
    Hoofdgemeente: "QUIÉVRAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1006,
    Plaatsnaam: "Raad van de Vlaamse Gemeenschapscommissie",
    Deelgemeente: null,
    Hoofdgemeente: "Raad van de Vlaamse Gemeenschapscommissie",
    Provincie: null,
  },
  {
    Postcode: 6792,
    Plaatsnaam: "Rachecourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AUBANGE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4287,
    Plaatsnaam: "Racour",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINCENT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4730,
    Plaatsnaam: "Raeren",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RAEREN",
    Provincie: "LUIK",
  },
  {
    Postcode: 6532,
    Plaatsnaam: "Ragnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4987,
    Plaatsnaam: "Rahier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STOUMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 7971,
    Plaatsnaam: "Ramegnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7520,
    Plaatsnaam: "Ramegnies-Chin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4557,
    Plaatsnaam: "Ramelot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINLOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 1367,
    Plaatsnaam: "Ramillies",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RAMILLIES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1880,
    Plaatsnaam: "Ramsdonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KAPELLE-OP-DEN-BOS",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2230,
    Plaatsnaam: "Ramsel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERSELT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8301,
    Plaatsnaam: "Ramskapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KNOKKE-HEIST",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8620,
    Plaatsnaam: "Ramskapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIEUWPOORT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6470,
    Plaatsnaam: "Rance",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SIVRY-RANCE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6043,
    Plaatsnaam: "Ransart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3470,
    Plaatsnaam: "Ransberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENAKEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2520,
    Plaatsnaam: "Ranst",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RANST",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2380,
    Plaatsnaam: "Ravels",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RAVELS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7804,
    Plaatsnaam: "Rebaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1430,
    Plaatsnaam: "Rebecq-Rognon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "REBECQ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4780,
    Plaatsnaam: "Recht",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SANKT-VITH",
    Provincie: "LUIK",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Recogne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6890,
    Plaatsnaam: "Redu",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2840,
    Plaatsnaam: "Reet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RUMST",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3621,
    Plaatsnaam: "Rekem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANAKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8930,
    Plaatsnaam: "Rekkem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MENEN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1731,
    Plaatsnaam: "Relegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Remagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3791,
    Plaatsnaam: "Remersdaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VOEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4350,
    Plaatsnaam: "Remicourt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "REMICOURT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6987,
    Plaatsnaam: "Rendeux",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RENDEUX",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8647,
    Plaatsnaam: "Reninge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LO-RENINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8970,
    Plaatsnaam: "Reningelst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "POPERINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6500,
    Plaatsnaam: "Renlies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3950,
    Plaatsnaam: "Reppel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOCHOLT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7134,
    Plaatsnaam: "Ressaix",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9551,
    Plaatsnaam: "Ressegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6927,
    Plaatsnaam: "Resteigne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2470,
    Plaatsnaam: "Retie",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RETIE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4621,
    Plaatsnaam: "Retinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 4790,
    Plaatsnaam: "Reuland",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BURG-REULAND",
    Provincie: "LUIK",
  },
  {
    Postcode: 6210,
    Plaatsnaam: "Rèves",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LES BONS VILLERS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5080,
    Plaatsnaam: "Rhisnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA BRUYÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4600,
    Plaatsnaam: "Richelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VISÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Riemst",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Rienne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6464,
    Plaatsnaam: "Rièzes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Rijkel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2310,
    Plaatsnaam: "Rijkevorsel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RIJKEVORSEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Rijkhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2820,
    Plaatsnaam: "Rijmenam",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BONHEIDEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Riksingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3202,
    Plaatsnaam: "Rillaar",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AARSCHOT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5170,
    Plaatsnaam: "Rivière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PROFONDEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1330,
    Plaatsnaam: "Rixensart",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RIXENSART",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6460,
    Plaatsnaam: "Robechies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6769,
    Plaatsnaam: "Robelmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MEIX-DEVANT-VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4950,
    Plaatsnaam: "Robertville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WEISMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Roborst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Rochefort",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6830,
    Plaatsnaam: "Rochehaut",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4761,
    Plaatsnaam: "Rocherath",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BÜLLINGEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 4690,
    Plaatsnaam: "Roclenge-sur-Geer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASSENGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4000,
    Plaatsnaam: "Rocourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8972,
    Plaatsnaam: "Roesbrugge-Haringe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "POPERINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8800,
    Plaatsnaam: "Roeselare",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ROESELARE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5651,
    Plaatsnaam: "Rognée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7387,
    Plaatsnaam: "Roisin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HONNELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8460,
    Plaatsnaam: "Roksem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENBURG",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8510,
    Plaatsnaam: "Rollegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTRIJK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8880,
    Plaatsnaam: "Rollegem-Kapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEDEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4347,
    Plaatsnaam: "Roloux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FEXHE-LE-HAUT-CLOCHER",
    Provincie: "LUIK",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Roly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Romedenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Romerée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3730,
    Plaatsnaam: "Romershoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOESELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4624,
    Plaatsnaam: "Romsée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 7623,
    Plaatsnaam: "Rongy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7090,
    Plaatsnaam: "Ronquières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-LE-COMTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9600,
    Plaatsnaam: "Ronse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RONSE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9932,
    Plaatsnaam: "Ronsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIEVEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3370,
    Plaatsnaam: "Roosbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUTERSEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1760,
    Plaatsnaam: "Roosdaal",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ROOSDAAL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5620,
    Plaatsnaam: "Rosée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6250,
    Plaatsnaam: "Roselies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AISEAU-PRESLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1331,
    Plaatsnaam: "Rosières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIXENSART",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Rosmeer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4257,
    Plaatsnaam: "Rosoux-Crenwick",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERLOZ",
    Provincie: "LUIK",
  },
  {
    Postcode: 6730,
    Plaatsnaam: "Rossignol",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINTIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3650,
    Plaatsnaam: "Rotem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILSEN-STOKKEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4120,
    Plaatsnaam: "Rotheux-Rimière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUPRÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 3110,
    Plaatsnaam: "Rotselaar",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ROTSELAAR",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7601,
    Plaatsnaam: "Roucourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Rouveroy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4140,
    Plaatsnaam: "Rouvreux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SPRIMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6044,
    Plaatsnaam: "Roux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHARLEROI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1315,
    Plaatsnaam: "Roux-Miroir",
    Deelgemeente: "Ja",
    Hoofdgemeente: "INCOURT",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6900,
    Plaatsnaam: "Roy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MARCHE-EN-FAMENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Rozebeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1044,
    Plaatsnaam: "RTBF",
    Deelgemeente: null,
    Hoofdgemeente: "RTBF",
    Provincie: null,
  },
  {
    Postcode: 1033,
    Plaatsnaam: "RTL-TVI",
    Deelgemeente: null,
    Hoofdgemeente: "RTL-TVI",
    Provincie: null,
  },
  {
    Postcode: 8020,
    Plaatsnaam: "Ruddervoorde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTKAMP",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6760,
    Plaatsnaam: "Ruette",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9690,
    Plaatsnaam: "Ruien",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KLUISBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1601,
    Plaatsnaam: "Ruisbroek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-PIETERS-LEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2870,
    Plaatsnaam: "Ruisbroek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUURS-SINT-AMANDS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8755,
    Plaatsnaam: "Ruiselede",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RUISELEDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Rukkelingen-Loon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6724,
    Plaatsnaam: "Rulles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HABAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8800,
    Plaatsnaam: "Rumbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROESELARE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7610,
    Plaatsnaam: "Rumes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RUMES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7540,
    Plaatsnaam: "Rumillies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3454,
    Plaatsnaam: "Rummen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEETBETS",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Rumsdorp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2840,
    Plaatsnaam: "Rumst",
    Deelgemeente: "Neen",
    Hoofdgemeente: "RUMST",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3803,
    Plaatsnaam: "Runkelen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9150,
    Plaatsnaam: "Rupelmonde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUIBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7750,
    Plaatsnaam: "Russeignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONT-DE-L'ENCLUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Rutten",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5010,
    Plaatsnaam: "SA SudPresse",
    Deelgemeente: null,
    Hoofdgemeente: "SA SudPresse",
    Provincie: null,
  },
  {
    Postcode: 6221,
    Plaatsnaam: "Saint-Amand",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4606,
    Plaatsnaam: "Saint-André",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 5620,
    Plaatsnaam: "Saint-Aubin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7034,
    Plaatsnaam: "Saint-Denis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5081,
    Plaatsnaam: "Saint-Denis-Bovesse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA BRUYÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4470,
    Plaatsnaam: "Saint-Georges-sur-Meuse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SAINT-GEORGES-SUR-MEUSE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5640,
    Plaatsnaam: "Saint-Gérard",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Saint-Germain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1450,
    Plaatsnaam: "Saint-Géry",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHASTRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7330,
    Plaatsnaam: "Saint-Ghislain",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SAINT-GHISLAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6870,
    Plaatsnaam: "Saint-Hubert",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SAINT-HUBERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Saint-Jean-Geest",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6747,
    Plaatsnaam: "Saint-Léger",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SAINT-LÉGER",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7730,
    Plaatsnaam: "Saint-Léger",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTAIMPUIS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5003,
    Plaatsnaam: "Saint-Marc",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6762,
    Plaatsnaam: "Saint-Mard",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Saint-Martin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7500,
    Plaatsnaam: "Saint-Maur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6887,
    Plaatsnaam: "Saint-Médard",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERBEUMONT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4420,
    Plaatsnaam: "Saint-Nicolas",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SAINT-NICOLAS",
    Provincie: "LUIK",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Saint-Pierre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4672,
    Plaatsnaam: "Saint-Remy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BLÉGNY",
    Provincie: "LUIK",
  },
  {
    Postcode: 6460,
    Plaatsnaam: "Saint-Remy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Saint-Remy-Geest",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7912,
    Plaatsnaam: "Saint-Sauveur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5002,
    Plaatsnaam: "Saint-Servais",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4550,
    Plaatsnaam: "Saint-Séverin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NANDRIN",
    Provincie: "LUIK",
  },
  {
    Postcode: 7030,
    Plaatsnaam: "Saint-Symphorien",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7100,
    Plaatsnaam: "Saint-Vaast",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6730,
    Plaatsnaam: "Saint-Vincent",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINTIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6820,
    Plaatsnaam: "Sainte-Cécile",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6800,
    Plaatsnaam: "Sainte-Marie-Chevigny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBRAMONT-CHEVIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6740,
    Plaatsnaam: "Sainte-Marie-sur-Semois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ETALLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1480,
    Plaatsnaam: "Saintes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TUBIZE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4671,
    Plaatsnaam: "Saive",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BLÉGNY",
    Provincie: "LUIK",
  },
  {
    Postcode: 6460,
    Plaatsnaam: "Salles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Samart",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6982,
    Plaatsnaam: "Samrée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA ROCHE-EN-ARDENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4780,
    Plaatsnaam: "Sankt-Vith",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SANKT-VITH",
    Provincie: "LUIK",
  },
  {
    Postcode: 7080,
    Plaatsnaam: "Sars-la-Bruyère",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRAMERIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6542,
    Plaatsnaam: "Sars-la-Buissière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOBBES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5330,
    Plaatsnaam: "Sart-Bernard",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSESSE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Sart-Custinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1495,
    Plaatsnaam: "Sart-Dames-Avelines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LA-VILLE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Sart-en-Fagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5070,
    Plaatsnaam: "Sart-Eustache",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FOSSES-LA-VILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4845,
    Plaatsnaam: "Sart-lez-Spa",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JALHAY",
    Provincie: "LUIK",
  },
  {
    Postcode: 5070,
    Plaatsnaam: "Sart-Saint-Laurent",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FOSSES-LA-VILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6470,
    Plaatsnaam: "Sautin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SIVRY-RANCE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Sautour",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5030,
    Plaatsnaam: "Sauvenière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEMBLOUX",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1101,
    Plaatsnaam: "Scanning",
    Deelgemeente: null,
    Hoofdgemeente: "Scanning",
    Provincie: null,
  },
  {
    Postcode: 1030,
    Plaatsnaam: "Schaarbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SCHAARBEEK",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 3290,
    Plaatsnaam: "Schaffen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIEST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3732,
    Plaatsnaam: "Schalkhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOESELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5364,
    Plaatsnaam: "Schaltin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9820,
    Plaatsnaam: "Schelderode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MERELBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9860,
    Plaatsnaam: "Scheldewindeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2627,
    Plaatsnaam: "Schelle",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SCHELLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9260,
    Plaatsnaam: "Schellebelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WICHELEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9506,
    Plaatsnaam: "Schendelbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1703,
    Plaatsnaam: "Schepdaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3270,
    Plaatsnaam: "Scherpenheuvel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SCHERPENHEUVEL-ZICHEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2970,
    Plaatsnaam: "Schilde",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SCHILDE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Schoonaarde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8433,
    Plaatsnaam: "Schore",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9688,
    Plaatsnaam: "Schorisse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAARKEDAL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2900,
    Plaatsnaam: "Schoten",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SCHOTEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2223,
    Plaatsnaam: "Schriek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEIST-OP-DEN-BERG",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8700,
    Plaatsnaam: "Schuiferskapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIELT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3540,
    Plaatsnaam: "Schulen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERK-DE-STAD",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4782,
    Plaatsnaam: "Schönberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SANKT-VITH",
    Provincie: "LUIK",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Sclayn",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5361,
    Plaatsnaam: "Scy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Seilles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6781,
    Plaatsnaam: "Sélange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MESSANCY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6596,
    Plaatsnaam: "Seloignes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MOMIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9890,
    Plaatsnaam: "Semmerzake",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GAVERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7180,
    Plaatsnaam: "Seneffe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SENEFFE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6832,
    Plaatsnaam: "Sensenruth",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4557,
    Plaatsnaam: "Seny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINLOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 5630,
    Plaatsnaam: "Senzeilles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CERFONTAINE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6940,
    Plaatsnaam: "Septon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4100,
    Plaatsnaam: "Seraing",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SERAING",
    Provincie: "LUIK",
  },
  {
    Postcode: 4537,
    Plaatsnaam: "Seraing-le-Château",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERLAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Serinchamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9260,
    Plaatsnaam: "Serskamp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WICHELEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5521,
    Plaatsnaam: "Serville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ONHAYE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7010,
    Plaatsnaam: "SHAPE",
    Deelgemeente: null,
    Hoofdgemeente: "SHAPE",
    Provincie: null,
  },
  {
    Postcode: 6640,
    Plaatsnaam: "Sibret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VAUX-SUR-SÛRE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6750,
    Plaatsnaam: "Signeulx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MUSSON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8340,
    Plaatsnaam: "Sijsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DAMME",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5630,
    Plaatsnaam: "Silenrieux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CERFONTAINE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Silly",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9112,
    Plaatsnaam: "Sinaai-Waas",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-NIKLAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Sinsin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1082,
    Plaatsnaam: "Sint-Agatha-Berchem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-AGATHA-BERCHEM",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 3040,
    Plaatsnaam: "Sint-Agatha-Rode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HULDENBERG",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2890,
    Plaatsnaam: "Sint-Amands",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PUURS-SINT-AMANDS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9040,
    Plaatsnaam: "Sint-Amandsberg",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8200,
    Plaatsnaam: "Sint-Andries",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9550,
    Plaatsnaam: "Sint-Antelinks",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8710,
    Plaatsnaam: "Sint-Baafs-Vijve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WIELSBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Sint-Blasius-Boekel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8554,
    Plaatsnaam: "Sint-Denijs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWEVEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Sint-Denijs-Boekel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9051,
    Plaatsnaam: "Sint-Denijs-Westrem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8793,
    Plaatsnaam: "Sint-Eloois-Vijve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WAREGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8880,
    Plaatsnaam: "Sint-Eloois-Winkel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEDEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1640,
    Plaatsnaam: "Sint-Genesius-Rode",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-GENESIUS-RODE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1060,
    Plaatsnaam: "Sint-Gillis",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-GILLIS",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 9200,
    Plaatsnaam: "Sint-Gillis-Dendermonde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERMONDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9170,
    Plaatsnaam: "Sint-Gillis-Waas",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-GILLIS-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Sint-Goriks-Oudenhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3730,
    Plaatsnaam: "Sint-Huibrechts-Hern",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOESELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3910,
    Plaatsnaam: "Sint-Huibrechts-Lille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Sint-Jacobs-Kapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8900,
    Plaatsnaam: "Sint-Jan",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9982,
    Plaatsnaam: "Sint-Jan-in-Eremo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LAUREINS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1080,
    Plaatsnaam: "Sint-Jans-Molenbeek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-JANS-MOLENBEEK",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 2960,
    Plaatsnaam: "Sint-Job-in-'t-Goor",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRECHT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1210,
    Plaatsnaam: "Sint-Joost-ten-Node",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-JOOST-TEN-NODE",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 8620,
    Plaatsnaam: "Sint-Joris",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIEUWPOORT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8730,
    Plaatsnaam: "Sint-Joris",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEERNEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3051,
    Plaatsnaam: "Sint-Joris-Weert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUD-HEVERLEE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3390,
    Plaatsnaam: "Sint-Joris-Winge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIELT-WINGE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2860,
    Plaatsnaam: "Sint-Katelijne-Waver",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-KATELIJNE-WAVER",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1742,
    Plaatsnaam: "Sint-Katherina-Lombeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TERNAT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9667,
    Plaatsnaam: "Sint-Kornelis-Horebeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOREBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8310,
    Plaatsnaam: "Sint-Kruis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9042,
    Plaatsnaam: "Sint-Kruis-Winkel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1750,
    Plaatsnaam: "Sint-Kwintens-Lennik",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LENNIK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3500,
    Plaatsnaam: "Sint-Lambrechts-Herk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1200,
    Plaatsnaam: "Sint-Lambrechts-Woluwe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-LAMBRECHTS-WOLUWE",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 9980,
    Plaatsnaam: "Sint-Laureins",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-LAUREINS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1600,
    Plaatsnaam: "Sint-Laureins-Berchem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-PIETERS-LEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2960,
    Plaatsnaam: "Sint-Lenaarts",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRECHT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9550,
    Plaatsnaam: "Sint-Lievens-Esse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9520,
    Plaatsnaam: "Sint-Lievens-Houtem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-LIEVENS-HOUTEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9981,
    Plaatsnaam: "Sint-Margriete",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LAUREINS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Sint-Margriete-Houtem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3470,
    Plaatsnaam: "Sint-Margriete-Houtem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENAKEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9667,
    Plaatsnaam: "Sint-Maria-Horebeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOREBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9630,
    Plaatsnaam: "Sint-Maria-Latem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZWALM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9570,
    Plaatsnaam: "Sint-Maria-Lierde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIERDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Sint-Maria-Oudenhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Sint-Maria-Oudenhove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1700,
    Plaatsnaam: "Sint-Martens-Bodegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9830,
    Plaatsnaam: "Sint-Martens-Latem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-MARTENS-LATEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Sint-Martens-Leerne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1750,
    Plaatsnaam: "Sint-Martens-Lennik",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LENNIK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9572,
    Plaatsnaam: "Sint-Martens-Lierde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIERDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3790,
    Plaatsnaam: "Sint-Martens-Voeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VOEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8200,
    Plaatsnaam: "Sint-Michiels",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9100,
    Plaatsnaam: "Sint-Niklaas",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-NIKLAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9170,
    Plaatsnaam: "Sint-Pauwels",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-GILLIS-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1541,
    Plaatsnaam: "Sint-Pieters-Kapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERNE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8433,
    Plaatsnaam: "Sint-Pieters-Kapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1600,
    Plaatsnaam: "Sint-Pieters-Leeuw",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-PIETERS-LEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3220,
    Plaatsnaam: "Sint-Pieters-Rode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOLSBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3792,
    Plaatsnaam: "Sint-Pieters-Voeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VOEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1150,
    Plaatsnaam: "Sint-Pieters-Woluwe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-PIETERS-WOLUWE",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 8690,
    Plaatsnaam: "Sint-Rijkers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1932,
    Plaatsnaam: "Sint-Stevens-Woluwe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZAVENTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Sint-Truiden",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1700,
    Plaatsnaam: "Sint-Ulriks-Kapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILBEEK",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 612,
    Plaatsnaam: "Sinterklaas",
    Deelgemeente: null,
    Hoofdgemeente: "Sinterklaas",
    Provincie: null,
  },
  {
    Postcode: 4851,
    Plaatsnaam: "Sippenaeken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PLOMBIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 7332,
    Plaatsnaam: "Sirault",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-GHISLAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6470,
    Plaatsnaam: "Sivry",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SIVRY-RANCE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9940,
    Plaatsnaam: "Sleidinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EVERGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8433,
    Plaatsnaam: "Slijpe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4450,
    Plaatsnaam: "Slins",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Sluizen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9506,
    Plaatsnaam: "Smeerebbe-Vloerzegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9340,
    Plaatsnaam: "Smetlede",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6890,
    Plaatsnaam: "Smuid",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8470,
    Plaatsnaam: "Snaaskerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GISTEL",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8490,
    Plaatsnaam: "Snellegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JABBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4557,
    Plaatsnaam: "Soheit-Tinlot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TINLOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6920,
    Plaatsnaam: "Sohier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7060,
    Plaatsnaam: "Soignies",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SOIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4861,
    Plaatsnaam: "Soiron",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINSTER",
    Provincie: "LUIK",
  },
  {
    Postcode: 6500,
    Plaatsnaam: "Solre-Saint-Géry",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6560,
    Plaatsnaam: "Solre-sur-Sambre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERQUELINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5140,
    Plaatsnaam: "Sombreffe",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SOMBREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Somme-Leuze",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6769,
    Plaatsnaam: "Sommethonne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MEIX-DEVANT-VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5523,
    Plaatsnaam: "Sommière",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ONHAYE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5651,
    Plaatsnaam: "Somzée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5340,
    Plaatsnaam: "Sorée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GESVES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5333,
    Plaatsnaam: "Sorinne-la-Longue",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSESSE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5503,
    Plaatsnaam: "Sorinnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5537,
    Plaatsnaam: "Sosoye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANHÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4920,
    Plaatsnaam: "Sougné-Remouchamps",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AYWAILLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Soulme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4630,
    Plaatsnaam: "Soumagne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SOUMAGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5630,
    Plaatsnaam: "Soumoy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CERFONTAINE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4950,
    Plaatsnaam: "Sourbrodt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WEISMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 6182,
    Plaatsnaam: "Souvret",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COURCELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5590,
    Plaatsnaam: "Sovet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CINEY",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6997,
    Plaatsnaam: "Soy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EREZÉE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5150,
    Plaatsnaam: "Soye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLOREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4900,
    Plaatsnaam: "Spa",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SPA",
    Provincie: "LUIK",
  },
  {
    Postcode: 3510,
    Plaatsnaam: "Spalbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7032,
    Plaatsnaam: "Spiennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8587,
    Plaatsnaam: "Spiere",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SPIERE-HELKIJN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Spontin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4140,
    Plaatsnaam: "Sprimont",
    Deelgemeente: "Neen",
    Hoofdgemeente: "SPRIMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 5190,
    Plaatsnaam: "Spy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JEMEPPE-SUR-SAMBRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2940,
    Plaatsnaam: "Stabroek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "STABROEK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8840,
    Plaatsnaam: "Staden",
    Deelgemeente: "Neen",
    Hoofdgemeente: "STADEN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8490,
    Plaatsnaam: "Stalhille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JABBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7973,
    Plaatsnaam: "Stambruges",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5646,
    Plaatsnaam: "Stave",
    Deelgemeente: "Ja",
    Hoofdgemeente: "METTET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8691,
    Plaatsnaam: "Stavele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ALVERINGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4970,
    Plaatsnaam: "Stavelot",
    Deelgemeente: "Neen",
    Hoofdgemeente: "STAVELOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 9140,
    Plaatsnaam: "Steendorp",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TEMSE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1840,
    Plaatsnaam: "Steenhuffel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LONDERZEEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9550,
    Plaatsnaam: "Steenhuize-Wijnhuize",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Steenkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7090,
    Plaatsnaam: "Steenkerque",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-LE-COMTE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1820,
    Plaatsnaam: "Steenokkerzeel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "STEENOKKERZEEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9190,
    Plaatsnaam: "Stekene",
    Deelgemeente: "Neen",
    Hoofdgemeente: "STEKENE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4801,
    Plaatsnaam: "Stembert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VERVIERS",
    Provincie: "LUIK",
  },
  {
    Postcode: 8400,
    Plaatsnaam: "Stene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTENDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1933,
    Plaatsnaam: "Sterrebeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZAVENTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3512,
    Plaatsnaam: "Stevoort",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3650,
    Plaatsnaam: "Stokkem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DILSEN-STOKKEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3511,
    Plaatsnaam: "Stokrooie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4987,
    Plaatsnaam: "Stoumont",
    Deelgemeente: "Neen",
    Hoofdgemeente: "STOUMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6887,
    Plaatsnaam: "Straimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERBEUMONT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6511,
    Plaatsnaam: "Strée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4577,
    Plaatsnaam: "Strée-lez-Huy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MODAVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 7110,
    Plaatsnaam: "Strépy-Bracquegnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Strijpen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1760,
    Plaatsnaam: "Strijtem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROOSDAAL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1853,
    Plaatsnaam: "Strombeek-Bever",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRIMBERGEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Stuivekenskerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5020,
    Plaatsnaam: "Suarlée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Sugny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Surice",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6812,
    Plaatsnaam: "Suxy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHINY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6661,
    Plaatsnaam: "Tailles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUFFALIZE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7618,
    Plaatsnaam: "Taintignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RUMES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5060,
    Plaatsnaam: "Tamines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAMBREVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5651,
    Plaatsnaam: "Tarcienne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4163,
    Plaatsnaam: "Tavier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTHISNES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Taviers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6662,
    Plaatsnaam: "Tavigny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUFFALIZE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6927,
    Plaatsnaam: "Tellin",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7520,
    Plaatsnaam: "Templeuve",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5020,
    Plaatsnaam: "Temploux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9140,
    Plaatsnaam: "Temse",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TEMSE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6970,
    Plaatsnaam: "Tenneville",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TENNEVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1790,
    Plaatsnaam: "Teralfene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AFFLIGEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2840,
    Plaatsnaam: "Terhagen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RUMST",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 6813,
    Plaatsnaam: "Termes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHINY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1740,
    Plaatsnaam: "Ternat",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TERNAT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7333,
    Plaatsnaam: "Tertre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-GHISLAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3080,
    Plaatsnaam: "Tervuren",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TERVUREN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4560,
    Plaatsnaam: "Terwagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CLAVIER",
    Provincie: "LUIK",
  },
  {
    Postcode: 3980,
    Plaatsnaam: "Tessenderlo",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TESSENDERLO",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3272,
    Plaatsnaam: "Testelt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SCHERPENHEUVEL-ZICHEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3793,
    Plaatsnaam: "Teuven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VOEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4910,
    Plaatsnaam: "Theux",
    Deelgemeente: "Neen",
    Hoofdgemeente: "THEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 6717,
    Plaatsnaam: "Thiaumont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATTERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7070,
    Plaatsnaam: "Thieu",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LE ROEULX",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7901,
    Plaatsnaam: "Thieulain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7061,
    Plaatsnaam: "Thieusies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOIGNIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6230,
    Plaatsnaam: "Thiméon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PONT-À-CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4890,
    Plaatsnaam: "Thimister",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THIMISTER-CLERMONT",
    Provincie: "LUIK",
  },
  {
    Postcode: 7533,
    Plaatsnaam: "Thimougies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1402,
    Plaatsnaam: "Thines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIVELLES",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6500,
    Plaatsnaam: "Thirimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUMONT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Thisnes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4791,
    Plaatsnaam: "Thommen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BURG-REULAND",
    Provincie: "LUIK",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Thon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1360,
    Plaatsnaam: "Thorembais-les-Béguines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PERWEZ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1360,
    Plaatsnaam: "Thorembais-Saint-Trond",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PERWEZ",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7830,
    Plaatsnaam: "Thoricourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SILLY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6536,
    Plaatsnaam: "Thuillies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6530,
    Plaatsnaam: "Thuin",
    Deelgemeente: "Neen",
    Hoofdgemeente: "THUIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7350,
    Plaatsnaam: "Thulin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HENSIES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7971,
    Plaatsnaam: "Thumaide",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5621,
    Plaatsnaam: "Thy-le-Bauduin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENNES",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5651,
    Plaatsnaam: "Thy-le-Château",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5502,
    Plaatsnaam: "Thynes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DINANT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4367,
    Plaatsnaam: "Thys",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CRISNÉE",
    Provincie: "LUIK",
  },
  {
    Postcode: 8573,
    Plaatsnaam: "Tiegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2460,
    Plaatsnaam: "Tielen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KASTERLEE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9140,
    Plaatsnaam: "Tielrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TEMSE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3390,
    Plaatsnaam: "Tielt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIELT-WINGE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8700,
    Plaatsnaam: "Tielt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TIELT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Tienen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4630,
    Plaatsnaam: "Tignée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOUMAGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4500,
    Plaatsnaam: "Tihange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HUY",
    Provincie: "LUIK",
  },
  {
    Postcode: 3150,
    Plaatsnaam: "Tildonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAACHT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4130,
    Plaatsnaam: "Tilff",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESNEUX",
    Provincie: "LUIK",
  },
  {
    Postcode: 6680,
    Plaatsnaam: "Tillet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINTE-ODE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4420,
    Plaatsnaam: "Tilleur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-NICOLAS",
    Provincie: "LUIK",
  },
  {
    Postcode: 5380,
    Plaatsnaam: "Tillier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERNELMONT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1495,
    Plaatsnaam: "Tilly",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LA-VILLE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4557,
    Plaatsnaam: "Tinlot",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TINLOT",
    Provincie: "LUIK",
  },
  {
    Postcode: 6637,
    Plaatsnaam: "Tintange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FAUVILLERS",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6730,
    Plaatsnaam: "Tintigny",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TINTIGNY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2830,
    Plaatsnaam: "Tisselt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WILLEBROEK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 6700,
    Plaatsnaam: "Toernich",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ARLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6941,
    Plaatsnaam: "Tohogne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1570,
    Plaatsnaam: "Tollembeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GALMAARDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Tongeren",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2260,
    Plaatsnaam: "Tongerlo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WESTERLO",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3960,
    Plaatsnaam: "Tongerlo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BREE",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7951,
    Plaatsnaam: "Tongre-Notre-Dame",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIÈVRES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7950,
    Plaatsnaam: "Tongre-Saint-Martin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIÈVRES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5140,
    Plaatsnaam: "Tongrinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMBREFFE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6717,
    Plaatsnaam: "Tontelange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATTERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6767,
    Plaatsnaam: "Torgny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROUVROY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8820,
    Plaatsnaam: "Torhout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TORHOUT",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4263,
    Plaatsnaam: "Tourinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 1320,
    Plaatsnaam: "Tourinnes-la-Grosse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAUVECHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1457,
    Plaatsnaam: "Tourinnes-Saint-Lambert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 7500,
    Plaatsnaam: "Tournai",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6840,
    Plaatsnaam: "Tournay",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NEUFCHÂTEAU",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7904,
    Plaatsnaam: "Tourpes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6890,
    Plaatsnaam: "Transinne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6183,
    Plaatsnaam: "Trazegnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COURCELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Treignes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4670,
    Plaatsnaam: "Trembleur",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BLÉGNY",
    Provincie: "LUIK",
  },
  {
    Postcode: 3120,
    Plaatsnaam: "Tremelo",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TREMELO",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7100,
    Plaatsnaam: "Trivières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA LOUVIÈRE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Trognée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4980,
    Plaatsnaam: "Trois-Ponts",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TROIS-PONTS",
    Provincie: "LUIK",
  },
  {
    Postcode: 1480,
    Plaatsnaam: "Tubize",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TUBIZE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 2300,
    Plaatsnaam: "Turnhout",
    Deelgemeente: "Neen",
    Hoofdgemeente: "TURNHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 6833,
    Plaatsnaam: "Ucimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3631,
    Plaatsnaam: "Uikhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9290,
    Plaatsnaam: "Uitbergen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERLARE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8370,
    Plaatsnaam: "Uitkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BLANKENBERGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1180,
    Plaatsnaam: "Ukkel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "UKKEL",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 3832,
    Plaatsnaam: "Ulbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WELLEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Upigny",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9910,
    Plaatsnaam: "Ursel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AALTER",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3054,
    Plaatsnaam: "Vaalbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUD-HEVERLEE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Val-Meer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6741,
    Plaatsnaam: "Vance",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ETALLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 2431,
    Plaatsnaam: "Varendonk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LAAKDAL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8490,
    Plaatsnaam: "Varsenare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JABBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Vaucelles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7536,
    Plaatsnaam: "Vaulx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6462,
    Plaatsnaam: "Vaulx-lez-Chimay",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6960,
    Plaatsnaam: "Vaux-Chavanne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MANHAY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4530,
    Plaatsnaam: "Vaux-et-Borset",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LE-BOUILLET",
    Provincie: "LUIK",
  },
  {
    Postcode: 6640,
    Plaatsnaam: "Vaux-lez-Rosières",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VAUX-SUR-SÛRE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4051,
    Plaatsnaam: "Vaux-sous-Chèvremont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHAUDFONTAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6640,
    Plaatsnaam: "Vaux-sur-Sûre",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VAUX-SUR-SÛRE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Vechmaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5020,
    Plaatsnaam: "Vedrin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2431,
    Plaatsnaam: "Veerle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LAAKDAL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 5060,
    Plaatsnaam: "Velaine-sur-Sambre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAMBREVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7760,
    Plaatsnaam: "Velaines",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8210,
    Plaatsnaam: "Veldegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZEDELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3620,
    Plaatsnaam: "Veldwezelt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANAKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Vellereille-le-Sec",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7120,
    Plaatsnaam: "Vellereille-les-Brayeux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ESTINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3806,
    Plaatsnaam: "Velm",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4460,
    Plaatsnaam: "Velroux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GRÂCE-HOLLOGNE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3020,
    Plaatsnaam: "Veltem-Beisem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERENT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Velzeke-Ruddershove",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Vencimont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1005,
    Plaatsnaam: "Verenigde Vergadering van de Gemeenschappelijke ",
    Deelgemeente: null,
    Hoofdgemeente: "Verenigde Vergadering van de Gemeenschappelijke ",
    Provincie: null,
  },
  {
    Postcode: 6440,
    Plaatsnaam: "Vergnies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FROIDCHAPELLE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4537,
    Plaatsnaam: "Verlaine",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VERLAINE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5370,
    Plaatsnaam: "Verlée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAVELANGE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9130,
    Plaatsnaam: "Verrebroek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3370,
    Plaatsnaam: "Vertrijk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUTERSEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4800,
    Plaatsnaam: "Verviers",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VERVIERS",
    Provincie: "LUIK",
  },
  {
    Postcode: 6870,
    Plaatsnaam: "Vesqueville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-HUBERT",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 3870,
    Plaatsnaam: "Veulen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEERS",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Veurne",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5300,
    Plaatsnaam: "Vezin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANDENNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7538,
    Plaatsnaam: "Vezon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Viane",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8570,
    Plaatsnaam: "Vichte",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANZEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6690,
    Plaatsnaam: "Vielsalm",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VIELSALM",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4317,
    Plaatsnaam: "Viemme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FAIMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 2240,
    Plaatsnaam: "Viersel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZANDHOVEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4577,
    Plaatsnaam: "Vierset-Barse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MODAVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 5670,
    Plaatsnaam: "Vierves-sur-Viroin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VIROINVAL",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6230,
    Plaatsnaam: "Viesville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PONT-À-CELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1472,
    Plaatsnaam: "Vieux-Genappe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4530,
    Plaatsnaam: "Vieux-Waleffe",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LE-BOUILLET",
    Provincie: "LUIK",
  },
  {
    Postcode: 4190,
    Plaatsnaam: "Vieuxville",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERRIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 6890,
    Plaatsnaam: "Villance",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIBIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4260,
    Plaatsnaam: "Ville-en-Hesbaye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAIVES",
    Provincie: "LUIK",
  },
  {
    Postcode: 7322,
    Plaatsnaam: "Ville-Pommeroeul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BERNISSART",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7070,
    Plaatsnaam: "Ville-sur-Haine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LE ROEULX",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7334,
    Plaatsnaam: "Villerot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SAINT-GHISLAIN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4161,
    Plaatsnaam: "Villers-aux-Tours",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTHISNES",
    Provincie: "LUIK",
  },
  {
    Postcode: 5630,
    Plaatsnaam: "Villers-Deux-Eglises",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CERFONTAINE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6823,
    Plaatsnaam: "Villers-devant-Orval",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLORENVILLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Villers-en-Fagne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4340,
    Plaatsnaam: "Villers-l'Evêque",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AWANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 6600,
    Plaatsnaam: "Villers-la-Bonne-Eau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6769,
    Plaatsnaam: "Villers-la-Loue",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MEIX-DEVANT-VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 6460,
    Plaatsnaam: "Villers-la-Tour",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1495,
    Plaatsnaam: "Villers-la-Ville",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VILLERS-LA-VILLE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4530,
    Plaatsnaam: "Villers-le-Bouillet",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VILLERS-LE-BOUILLET",
    Provincie: "LUIK",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Villers-le-Gambon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Villers-le-Peuplier",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4550,
    Plaatsnaam: "Villers-le-Temple",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NANDRIN",
    Provincie: "LUIK",
  },
  {
    Postcode: 5080,
    Plaatsnaam: "Villers-lez-Heest",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA BRUYÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7812,
    Plaatsnaam: "Villers-Notre-Dame",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6210,
    Plaatsnaam: "Villers-Perwin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LES BONS VILLERS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6280,
    Plaatsnaam: "Villers-Poterie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERPINNES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7812,
    Plaatsnaam: "Villers-Saint-Amand",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ATH",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7031,
    Plaatsnaam: "Villers-Saint-Ghislain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MONS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4453,
    Plaatsnaam: "Villers-Saint-Siméon",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6941,
    Plaatsnaam: "Villers-Sainte-Gertrude",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Villers-sur-Lesse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6740,
    Plaatsnaam: "Villers-sur-Semois",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ETALLE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1800,
    Plaatsnaam: "Vilvoorde",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VILVOORDE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4520,
    Plaatsnaam: "Vinalmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WANZE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9921,
    Plaatsnaam: "Vinderhoute",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIEVEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Vinkem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Vinkt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 6461,
    Plaatsnaam: "Virelles",
    Deelgemeente: "Ja",
    Hoofdgemeente: "CHIMAY",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1460,
    Plaatsnaam: "Virginal-Samme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ITTRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 6760,
    Plaatsnaam: "Virton",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VIRTON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 4600,
    Plaatsnaam: "Visé",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VISÉ",
    Provincie: "LUIK",
  },
  {
    Postcode: 3300,
    Plaatsnaam: "Vissenaken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TIENEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 7511,
    Plaatsnaam: "Vitrine Magique",
    Deelgemeente: null,
    Hoofdgemeente: "Vitrine Magique",
    Provincie: null,
  },
  {
    Postcode: 5070,
    Plaatsnaam: "Vitrival",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FOSSES-LA-VILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4683,
    Plaatsnaam: "Vivegnis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUPEYE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6833,
    Plaatsnaam: "Vivy",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUILLON",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1011,
    Plaatsnaam: "Vlaams Parlement",
    Deelgemeente: null,
    Hoofdgemeente: "Vlaams Parlement",
    Provincie: null,
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Vladslo",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8908,
    Plaatsnaam: "Vlamertinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9420,
    Plaatsnaam: "Vlekkem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ERPE-MERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1602,
    Plaatsnaam: "Vlezenbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-PIETERS-LEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3724,
    Plaatsnaam: "Vliermaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTESSEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3721,
    Plaatsnaam: "Vliermaalroot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTESSEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9520,
    Plaatsnaam: "Vlierzele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LIEVENS-HOUTEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Vlijtingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2340,
    Plaatsnaam: "Vlimmeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEERSE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8421,
    Plaatsnaam: "Vlissegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DE HAAN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7880,
    Plaatsnaam: "Vloesberg",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VLOESBERG",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5600,
    Plaatsnaam: "Vodecée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PHILIPPEVILLE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5680,
    Plaatsnaam: "Vodelée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOISCHE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Vogenée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Volkegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1570,
    Plaatsnaam: "Vollezele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GALMAARDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Vonêche",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9400,
    Plaatsnaam: "Voorde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NINOVE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8902,
    Plaatsnaam: "Voormezele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3840,
    Plaatsnaam: "Voort",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORGLOON",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 4347,
    Plaatsnaam: "Voroux-Goreux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FEXHE-LE-HAUT-CLOCHER",
    Provincie: "LUIK",
  },
  {
    Postcode: 4451,
    Plaatsnaam: "Voroux-lez-Liers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 2290,
    Plaatsnaam: "Vorselaar",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VORSELAAR",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3890,
    Plaatsnaam: "Vorsen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GINGELOM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1190,
    Plaatsnaam: "Vorst",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VORST",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 2430,
    Plaatsnaam: "Vorst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LAAKDAL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2350,
    Plaatsnaam: "Vosselaar",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VOSSELAAR",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9850,
    Plaatsnaam: "Vosselare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3080,
    Plaatsnaam: "Vossem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TERVUREN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4041,
    Plaatsnaam: "Vottem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERSTAL",
    Provincie: "LUIK",
  },
  {
    Postcode: 9120,
    Plaatsnaam: "Vrasene",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEVEREN-WAAS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2531,
    Plaatsnaam: "Vremde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOECHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Vreren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5550,
    Plaatsnaam: "Vresse-sur-Semois",
    Deelgemeente: "Neen",
    Hoofdgemeente: "VRESSE-SUR-SEMOIS",
    Provincie: "NAMEN",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Vroenhoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1043,
    Plaatsnaam: "VRT",
    Deelgemeente: null,
    Hoofdgemeente: "VRT",
    Provincie: null,
  },
  {
    Postcode: 1818,
    Plaatsnaam: "VTM",
    Deelgemeente: null,
    Hoofdgemeente: "VTM",
    Provincie: null,
  },
  {
    Postcode: 3630,
    Plaatsnaam: "Vucht",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MAASMECHELEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9890,
    Plaatsnaam: "Vurste",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GAVERE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4570,
    Plaatsnaam: "Vyle-et-Tharoul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MARCHIN",
    Provincie: "LUIK",
  },
  {
    Postcode: 3473,
    Plaatsnaam: "Waanrode",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTENAKEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9506,
    Plaatsnaam: "Waarbeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8020,
    Plaatsnaam: "Waardamme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTKAMP",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2550,
    Plaatsnaam: "Waarloos",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KONTICH",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8581,
    Plaatsnaam: "Waarmaarde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "AVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9950,
    Plaatsnaam: "Waarschoot",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIEVEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3401,
    Plaatsnaam: "Waasmont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9250,
    Plaatsnaam: "Waasmunster",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WAASMUNSTER",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7784,
    Plaatsnaam: "Waasten",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOMEN-WAASTEN",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9185,
    Plaatsnaam: "Wachtebeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WACHTEBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7971,
    Plaatsnaam: "Wadelincourt",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BELOEIL",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6223,
    Plaatsnaam: "Wagnelée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6900,
    Plaatsnaam: "Waha",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MARCHE-EN-FAMENNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 5377,
    Plaatsnaam: "Waillet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SOMME-LEUZE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8720,
    Plaatsnaam: "Wakken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENTERGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Walcourt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2800,
    Plaatsnaam: "Walem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MECHELEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1457,
    Plaatsnaam: "Walhain-Saint-Paul",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALHAIN",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 4711,
    Plaatsnaam: "Walhorn",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LONTZEN",
    Provincie: "LUIK",
  },
  {
    Postcode: 3401,
    Plaatsnaam: "Walsbets",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3401,
    Plaatsnaam: "Walshoutem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3740,
    Plaatsnaam: "Waltwilder",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BILZEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1741,
    Plaatsnaam: "Wambeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TERNAT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Wancennes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4020,
    Plaatsnaam: "Wandre",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIÈGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 6224,
    Plaatsnaam: "Wanfercée-Baulet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3400,
    Plaatsnaam: "Wange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6220,
    Plaatsnaam: "Wangenies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FLEURUS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5564,
    Plaatsnaam: "Wanlin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUYET",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4980,
    Plaatsnaam: "Wanne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TROIS-PONTS",
    Provincie: "LUIK",
  },
  {
    Postcode: 7861,
    Plaatsnaam: "Wannebecq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LESSINES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 9772,
    Plaatsnaam: "Wannegem-Lede",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUISEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4280,
    Plaatsnaam: "Wansin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HANNUT",
    Provincie: "LUIK",
  },
  {
    Postcode: 4520,
    Plaatsnaam: "Wanze",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WANZE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9340,
    Plaatsnaam: "Wanzele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7548,
    Plaatsnaam: "Warchin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7740,
    Plaatsnaam: "Warcoing",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PECQ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 6600,
    Plaatsnaam: "Wardin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASTOGNE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8790,
    Plaatsnaam: "Waregem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WAREGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 4300,
    Plaatsnaam: "Waremme",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WAREMME",
    Provincie: "LUIK",
  },
  {
    Postcode: 4217,
    Plaatsnaam: "Waret-l'Évêque",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HÉRON",
    Provincie: "LUIK",
  },
  {
    Postcode: 5310,
    Plaatsnaam: "Waret-la-Chaussée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "EGHEZÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5080,
    Plaatsnaam: "Warisoulx",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LA BRUYÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5537,
    Plaatsnaam: "Warnant",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANHÉE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4530,
    Plaatsnaam: "Warnant-Dreye",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VILLERS-LE-BOUILLET",
    Provincie: "LUIK",
  },
  {
    Postcode: 7340,
    Plaatsnaam: "Warquignies",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COLFONTAINE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4608,
    Plaatsnaam: "Warsage",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DALHEM",
    Provincie: "LUIK",
  },
  {
    Postcode: 4590,
    Plaatsnaam: "Warzée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUFFET",
    Provincie: "LUIK",
  },
  {
    Postcode: 7340,
    Plaatsnaam: "Wasmes",
    Deelgemeente: "Ja",
    Hoofdgemeente: "COLFONTAINE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7604,
    Plaatsnaam: "Wasmes-Audemez-Briffoeil",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7390,
    Plaatsnaam: "Wasmuel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "QUAREGNON",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4219,
    Plaatsnaam: "Wasseiges",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WASSEIGES",
    Provincie: "LUIK",
  },
  {
    Postcode: 9988,
    Plaatsnaam: "Waterland-Oudeman",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LAUREINS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1410,
    Plaatsnaam: "Waterloo",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WATERLOO",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1170,
    Plaatsnaam: "Watermaal-Bosvoorde",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WATERMAAL-BOSVOORDE",
    Provincie: "BRUSSEL",
  },
  {
    Postcode: 9988,
    Plaatsnaam: "Watervliet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LAUREINS",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8978,
    Plaatsnaam: "Watou",
    Deelgemeente: "Ja",
    Hoofdgemeente: "POPERINGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7910,
    Plaatsnaam: "Wattripont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FRASNES-LEZ-ANVAING",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 7131,
    Plaatsnaam: "Waudrez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BINCHE",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5540,
    Plaatsnaam: "Waulsort",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASTIÈRE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 1440,
    Plaatsnaam: "Wauthier-Braine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAINE-LE-CHÂTEAU",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 1300,
    Plaatsnaam: "Wavre",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WAVRE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 5580,
    Plaatsnaam: "Wavreille",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROCHEFORT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 6210,
    Plaatsnaam: "Wayaux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LES BONS VILLERS",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 1474,
    Plaatsnaam: "Ways",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENAPPE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 3290,
    Plaatsnaam: "Webbekom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIEST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2275,
    Plaatsnaam: "Wechelderzande",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LILLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2381,
    Plaatsnaam: "Weelde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RAVELS",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 1982,
    Plaatsnaam: "Weerde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZEMST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2880,
    Plaatsnaam: "Weert",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BORNEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4860,
    Plaatsnaam: "Wegnez",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEPINSTER",
    Provincie: "LUIK",
  },
  {
    Postcode: 5523,
    Plaatsnaam: "Weillen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ONHAYE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4950,
    Plaatsnaam: "Weismes",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WEISMES",
    Provincie: "LUIK",
  },
  {
    Postcode: 9700,
    Plaatsnaam: "Welden",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENAARDE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 4840,
    Plaatsnaam: "Welkenraedt",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WELKENRAEDT",
    Provincie: "LUIK",
  },
  {
    Postcode: 9473,
    Plaatsnaam: "Welle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DENDERLEEUW",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3830,
    Plaatsnaam: "Wellen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WELLEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6920,
    Plaatsnaam: "Wellin",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WELLIN",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1780,
    Plaatsnaam: "Wemmel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WEMMEL",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8420,
    Plaatsnaam: "Wenduine",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DE HAAN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5100,
    Plaatsnaam: "Wépion",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 4190,
    Plaatsnaam: "Werbomont",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERRIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 3118,
    Plaatsnaam: "Werchter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROTSELAAR",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6940,
    Plaatsnaam: "Wéris",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DURBUY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 8610,
    Plaatsnaam: "Werken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTEMARK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3730,
    Plaatsnaam: "Werm",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOESELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8940,
    Plaatsnaam: "Wervik",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WERVIK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3150,
    Plaatsnaam: "Wespelaar",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HAACHT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8434,
    Plaatsnaam: "Westende",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2260,
    Plaatsnaam: "Westerlo",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WESTERLO",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8300,
    Plaatsnaam: "Westkapelle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KNOKKE-HEIST",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8460,
    Plaatsnaam: "Westkerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDENBURG",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2390,
    Plaatsnaam: "Westmalle",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MALLE",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2235,
    Plaatsnaam: "Westmeerbeek",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HULSHOUT",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8954,
    Plaatsnaam: "Westouter",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUVELLAND",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9230,
    Plaatsnaam: "Westrem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WETTEREN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8840,
    Plaatsnaam: "Westrozebeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "STADEN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8640,
    Plaatsnaam: "Westvleteren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VLETEREN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9230,
    Plaatsnaam: "Wetteren",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WETTEREN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8560,
    Plaatsnaam: "Wevelgem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WEVELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 7620,
    Plaatsnaam: "Wez-Velvain",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUNEHAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3111,
    Plaatsnaam: "Wezemaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ROTSELAAR",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 1970,
    Plaatsnaam: "Wezembeek-Oppem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WEZEMBEEK-OPPEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3401,
    Plaatsnaam: "Wezeren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LANDEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 6666,
    Plaatsnaam: "Wibrin",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOUFFALIZE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 9260,
    Plaatsnaam: "Wichelen",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WICHELEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3700,
    Plaatsnaam: "Widooie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TONGEREN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 2222,
    Plaatsnaam: "Wiekevorst",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEIST-OP-DEN-BERG",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8710,
    Plaatsnaam: "Wielsbeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WIELSBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 5100,
    Plaatsnaam: "Wierde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NAMUR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 7608,
    Plaatsnaam: "Wiers",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PÉRUWELZ",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5571,
    Plaatsnaam: "Wiesme",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9280,
    Plaatsnaam: "Wieze",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEBBEKE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 7370,
    Plaatsnaam: "Wihéries",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DOUR",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 4452,
    Plaatsnaam: "Wihogne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JUPRELLE",
    Provincie: "LUIK",
  },
  {
    Postcode: 3990,
    Plaatsnaam: "Wijchmaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "PEER",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3850,
    Plaatsnaam: "Wijer",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NIEUWERKERKEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 3018,
    Plaatsnaam: "Wijgmaal",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUVEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2110,
    Plaatsnaam: "Wijnegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WIJNEGEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3670,
    Plaatsnaam: "Wijshagen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OUDSBERGEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8953,
    Plaatsnaam: "Wijtschate",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUVELLAND",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3803,
    Plaatsnaam: "Wilderen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 7904,
    Plaatsnaam: "Willaupuis",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUZE-EN-HAINAUT",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 3370,
    Plaatsnaam: "Willebringen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BOUTERSEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2830,
    Plaatsnaam: "Willebroek",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WILLEBROEK",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 7506,
    Plaatsnaam: "Willemeau",
    Deelgemeente: "Ja",
    Hoofdgemeente: "TOURNAI",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 5575,
    Plaatsnaam: "Willerzie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GEDINNE",
    Provincie: "NAMEN",
  },
  {
    Postcode: 2610,
    Plaatsnaam: "Wilrijk",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3012,
    Plaatsnaam: "Wilsele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LEUVEN",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8431,
    Plaatsnaam: "Wilskerke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MIDDELKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3501,
    Plaatsnaam: "Wimmertingen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HASSELT",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 5570,
    Plaatsnaam: "Winenne",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BEAURAING",
    Provincie: "NAMEN",
  },
  {
    Postcode: 8750,
    Plaatsnaam: "Wingene",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WINGENE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3020,
    Plaatsnaam: "Winksele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERENT",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3722,
    Plaatsnaam: "Wintershoven",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTESSEM",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 6860,
    Plaatsnaam: "Witry",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LÉGLISE",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 7890,
    Plaatsnaam: "Wodecq",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ELLEZELLES",
    Provincie: "HENEGOUWEN",
  },
  {
    Postcode: 8640,
    Plaatsnaam: "Woesten",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VLETEREN",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 6780,
    Plaatsnaam: "Wolkrange",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MESSANCY",
    Provincie: "LUXEMBURG",
  },
  {
    Postcode: 1861,
    Plaatsnaam: "Wolvertem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "MEISE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 2160,
    Plaatsnaam: "Wommelgem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WOMMELGEM",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3350,
    Plaatsnaam: "Wommersom",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LINTER",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 4690,
    Plaatsnaam: "Wonck",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BASSENGE",
    Provincie: "LUIK",
  },
  {
    Postcode: 9032,
    Plaatsnaam: "Wondelgem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Wontergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9790,
    Plaatsnaam: "Wortegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WORTEGEM-PETEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2323,
    Plaatsnaam: "Wortel",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HOOGSTRATEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 9550,
    Plaatsnaam: "Woubrechtegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8600,
    Plaatsnaam: "Woumen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DIKSMUIDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8670,
    Plaatsnaam: "Wulpen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOKSIJDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8952,
    Plaatsnaam: "Wulvergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUVELLAND",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Wulveringem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2990,
    Plaatsnaam: "Wuustwezel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "WUUSTWEZEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 4652,
    Plaatsnaam: "Xhendelesse",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HERVE",
    Provincie: "LUIK",
  },
  {
    Postcode: 4432,
    Plaatsnaam: "Xhendremael",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANS",
    Provincie: "LUIK",
  },
  {
    Postcode: 4190,
    Plaatsnaam: "Xhoris",
    Deelgemeente: "Ja",
    Hoofdgemeente: "FERRIÈRES",
    Provincie: "LUIK",
  },
  {
    Postcode: 4550,
    Plaatsnaam: "Yernée-Fraineux",
    Deelgemeente: "Ja",
    Hoofdgemeente: "NANDRIN",
    Provincie: "LUIK",
  },
  {
    Postcode: 7513,
    Plaatsnaam: "Yves Rocher",
    Deelgemeente: null,
    Hoofdgemeente: "Yves Rocher",
    Provincie: null,
  },
  {
    Postcode: 5650,
    Plaatsnaam: "Yves-Gomezée",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WALCOURT",
    Provincie: "NAMEN",
  },
  {
    Postcode: 5530,
    Plaatsnaam: "Yvoir",
    Deelgemeente: "Neen",
    Hoofdgemeente: "YVOIR",
    Provincie: "NAMEN",
  },
  {
    Postcode: 9080,
    Plaatsnaam: "Zaffelare",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOCHRISTI",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9506,
    Plaatsnaam: "Zandbergen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8680,
    Plaatsnaam: "Zande",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KOEKELARE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 2240,
    Plaatsnaam: "Zandhoven",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZANDHOVEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2040,
    Plaatsnaam: "Zandvliet",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ANTWERPEN",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 8400,
    Plaatsnaam: "Zandvoorde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "OOSTENDE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8980,
    Plaatsnaam: "Zandvoorde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ZONNEBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9500,
    Plaatsnaam: "Zarlardinge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GERAARDSBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8610,
    Plaatsnaam: "Zarren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KORTEMARK",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1930,
    Plaatsnaam: "Zaventem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZAVENTEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8210,
    Plaatsnaam: "Zedelgem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZEDELGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8380,
    Plaatsnaam: "Zeebrugge",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRUGGE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9660,
    Plaatsnaam: "Zegelsem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "BRAKEL",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9240,
    Plaatsnaam: "Zele",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZELE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3545,
    Plaatsnaam: "Zelem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HALEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 1731,
    Plaatsnaam: "Zellik",
    Deelgemeente: "Ja",
    Hoofdgemeente: "ASSE",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 9060,
    Plaatsnaam: "Zelzate",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZELZATE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 1980,
    Plaatsnaam: "Zemst",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZEMST",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3800,
    Plaatsnaam: "Zepperen",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-TRUIDEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8490,
    Plaatsnaam: "Zerkegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JABBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 1370,
    Plaatsnaam: "Zétrud-Lumay",
    Deelgemeente: "Ja",
    Hoofdgemeente: "JODOIGNE",
    Provincie: "WAALS-BRABANT",
  },
  {
    Postcode: 8470,
    Plaatsnaam: "Zevekote",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GISTEL",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9080,
    Plaatsnaam: "Zeveneken",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LOCHRISTI",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9800,
    Plaatsnaam: "Zeveren",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DEINZE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9840,
    Plaatsnaam: "Zevergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "DE PINTE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3271,
    Plaatsnaam: "Zichem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SCHERPENHEUVEL-ZICHEM",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 3770,
    Plaatsnaam: "Zichen-Zussen-Bolder",
    Deelgemeente: "Ja",
    Hoofdgemeente: "RIEMST",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8902,
    Plaatsnaam: "Zillebeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9750,
    Plaatsnaam: "Zingem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KRUISEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2260,
    Plaatsnaam: "Zoerle-Parwijs",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WESTERLO",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 2980,
    Plaatsnaam: "Zoersel",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZOERSEL",
    Provincie: "ANTWERPEN",
  },
  {
    Postcode: 3550,
    Plaatsnaam: "Zolder",
    Deelgemeente: "Ja",
    Hoofdgemeente: "HEUSDEN-ZOLDER",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 9930,
    Plaatsnaam: "Zomergem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "LIEVEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3520,
    Plaatsnaam: "Zonhoven",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZONHOVEN",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8980,
    Plaatsnaam: "Zonnebeke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZONNEBEKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9520,
    Plaatsnaam: "Zonnegem",
    Deelgemeente: "Ja",
    Hoofdgemeente: "SINT-LIEVENS-HOUTEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9620,
    Plaatsnaam: "Zottegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZOTTEGEM",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 8630,
    Plaatsnaam: "Zoutenaaie",
    Deelgemeente: "Ja",
    Hoofdgemeente: "VEURNE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 3440,
    Plaatsnaam: "Zoutleeuw",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZOUTLEEUW",
    Provincie: "VLAAMS-BRABANT",
  },
  {
    Postcode: 8904,
    Plaatsnaam: "Zuidschote",
    Deelgemeente: "Ja",
    Hoofdgemeente: "IEPER",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8377,
    Plaatsnaam: "Zuienkerke",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZUIENKERKE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9870,
    Plaatsnaam: "Zulte",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZULTE",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 9690,
    Plaatsnaam: "Zulzeke",
    Deelgemeente: "Ja",
    Hoofdgemeente: "KLUISBERGEN",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 3690,
    Plaatsnaam: "Zutendaal",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZUTENDAAL",
    Provincie: "LIMBURG",
  },
  {
    Postcode: 8550,
    Plaatsnaam: "Zwevegem",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZWEVEGEM",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 8750,
    Plaatsnaam: "Zwevezele",
    Deelgemeente: "Ja",
    Hoofdgemeente: "WINGENE",
    Provincie: "WEST-VLAANDEREN",
  },
  {
    Postcode: 9052,
    Plaatsnaam: "Zwijnaarde",
    Deelgemeente: "Ja",
    Hoofdgemeente: "GENT",
    Provincie: "OOST-VLAANDEREN",
  },
  {
    Postcode: 2070,
    Plaatsnaam: "Zwijndrecht",
    Deelgemeente: "Neen",
    Hoofdgemeente: "ZWIJNDRECHT",
    Provincie: "ANTWERPEN",
  },
];

export default postcodes;
